/** Turkish translations — base language */
const tr = {
  // ─── Common ────────────────────────────────────────
  common: {
    privacyPre: "Kişisel verileriniz ",
    privacyLink: "KVKK Aydınlatma Metni",
    termsLink: "Kullanım Koşulları",
    privacyPost: " kapsamında işlenir.",
    all: "Tümü",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    add: "Ekle",
    adding: "Ekleniyor...",
    create: "Oluştur",
    creating: "Oluşturuluyor...",
    close: "Kapat",
    /** Belge yazımı reddedildi (409 stale_write): veri tazelendi. */
    staleWrite: "Bu kayıt siz düzenlerken başka bir yerden değişti. Güncel hâli yüklendi — değişikliğinizi kontrol edip yeniden kaydedin.",
    back: "Geri",
    loading: "Yükleniyor...",
    loadMore: "Daha fazla göster",
    perPage: "kayıt/sayfa",
    logout: "Çıkış",
    switchToLight: "Açık temaya geç",
    switchToDark: "Koyu temaya geç",
    error: "Hata",
    unknownError: "Bilinmeyen hata",
    errorOccurred: "Bir hata oluştu",
    confirm: "Onayla",
    phone: "Telefon",
    email: "E-posta",
    name: "İsim",
    date: "Tarih",
    actions: "İşlemler",
    yes: "Evet",
    no: "Hayır",
    none: "Yok",
    other: "Diğer",
    total: "Toplam",
    language: "Dil",
    uploading: "Yükleniyor...",
    upload: "Yükle",
    skip: "Atla",
    chooseFile: "Dosya seç",
    remove: "Kaldır",
    help: "Yardım",
    left: "kaldı",
    more: "Daha",
    otherPages: "Diğer Sayfalar",
    optional: "opsiyonel",
  },

  // ─── Navigation ────────────────────────────────────
  nav: {
    dashboard: "Dashboard",
    guests: "Misafirler",
    sms: "SMS",
    moderation: "Moderasyon",
    organizers: "Organizatörler",
    users: "Kullanıcılar",
    weddings: "Düğünler",
    myWeddings: "Düğünlerim",
    profile: "Profilim",
    home: "Ana Sayfa",
    rsvp: "RSVP",
    upload: "Yükle",
    gallery: "Galeri",
    slideshow: "Sahne",
    reji: "Reji",
    analytics: "QR Analitik",
    allWeddings: "Tüm Düğünler",
    backToWeddings: "Düğünlere Dön",
    organizer: "Organizatör",
    maintenance: "Hata Takibi",
    controlCenter: "Kontrol Merkezi",
    smsCenter: "SMS Merkezi",
    site: "Satış & Site",
    privacy: "KVKK Başvuruları",
    print: "Baskı",
    themes: "Temalar",
    settings: "Ayarlar",
    packages: "Paketlerim",
  },

  // ─── Auth (Guest — SMS OTP) ───────────────────────
  auth: {
    welcomeTitle: "Düğünümüze Hoş Geldiniz",
    loginTitle: "Login",
    loginDesc: "Telefonunuza SMS ile doğrulama kodu göndereceğiz",
    phoneLabel: "Telefon",
    login: "Giriş Yap",
    verifyTitle: "Doğrulama Kodu",
    verifyDesc: "Telefonunuza gelen 6 haneli SMS kodunu girin",
    codeLabel: "Kod",
    verify: "Doğrula",
    phonePlaceholder: "+90 5XX XXX XX XX",
    loggingIn: "Giriş yapılıyor...",
    enterCode: "Telefonunuza gelen 6 haneli SMS kodunu girin",
    verifying: "Doğrulanıyor...",
    wrongNumber: "Numarayı değiştir",
    changeNumber: "Numarayı değiştir",
    turnstileRequired: "Lütfen doğrulama kontrolünü tamamlayın",
    codeFailed: "Kod doğrulanamadı",
    logoutLabel: "Çıkış yap",
    codePlaceholder: "123456",
    otpUnavailable: "SMS doğrulama şu an kullanılamıyor. Lütfen organizatörle iletişime geçin.",
    invalidPhone: "Geçerli bir telefon numarası girin — 0 ile de başlayabilirsiniz.",
    countrySelectLabel: "Ülke kodu",
    countrySearchPlaceholder: "Ülke ara…",
    noCountryResults: "Ülke bulunamadı",
    phoneHint: "0 ile de yazabilirsiniz — otomatik düzeltiriz",
    banned: "Bu düğün için erişiminiz askıya alınmıştır. Lütfen organizatörle iletişime geçin.",
    celebrationPrefix: "Bir aşk hikayesi:",
    tabLogin: "Giriş Yap",
    tabRegister: "Kayıt Ol",
    registerTitle: "Kayıt Ol",
    registerDesc: "Düğüne katılmak için adını ve telefon numaranı gir.",
    alreadyRegisteredTitle: "Zaten kayıtlısın",
    alreadyRegisteredDesc: "Bu numarayla daha önce kayıt oldun — giriş yaparak devam et.",
    alreadyRegisteredSwitch: "Giriş yap",
  },

  // ─── Auth (Organizer — Email OTP) ──────────────────
  organizerAuth: {
    signupClosed: "Bu e-postayla kayıtlı bir organizatör hesabı yok. Yeni hesaplar şu an teklif üzerinden açılıyor — wedding.mertbal.com adresindeki formdan fiyat alabilirsiniz.",
    title: "Organizatör Giriş",
    emailPrompt: "E-posta adresinizi girin",
    codePrompt: "E-postanıza gönderilen kodu girin",
    emailLabel: "E-posta",
    sendCode: "Kod Gönder",
    verifyCode: "Doğrulama Kodu",
    login: "Giriş Yap",
    changeEmail: "Farklı e-posta kullan",
    emailPlaceholder: "organizer@example.com",
    panelTitle: "Organizatör Paneli",
    tagline: "Düğününüzü yönetin",
    welcomeBack: "Tekrar hoş geldiniz",
    verifyTitle: "Kimliğinizi doğrulayın",
    verifyHint: "{{email}} adresine bağlı bir hesap varsa 6 haneli kodu gönderdik. Hesap yoksa bu adrese bilgi e-postası gider.",
    signupVerifyHint: "Kodu {{email}} adresine gönderdik — girince hesabınız açılır.",
    noAccount: "Hesabınız yok mu?",
    signupCta: "Hesap oluşturun",
    quoteCta: "Teklif alın",
    haveAccount: "Zaten hesabınız var mı?",
    loginCta: "Giriş yapın",
    signupTitle: "Hesap oluşturun",
    signupPrompt: "Adınızı ve e-postanızı girin; e-postanıza gelen kodla hesabınız açılır.",
    nameLabel: "Ad soyad",
    namePlaceholder: "Ayşe Yılmaz",
    acceptTerms: "Kullanım koşullarını",
    acceptAnd: " ve ",
    acceptKvkk: "KVKK aydınlatma metnini",
    acceptPost: " okudum, kabul ediyorum.",
    createAccount: "Hesap oluştur",
    signupMissing: "Adınızı yazın ve koşulları onaylayın.",
    signupClosedTitle: "Yeni hesaplar teklif üzerinden açılıyor",
    signupClosedBody: "Fiyat ve bilgi için web sitemizdeki formu doldurun; hesabınızı biz açalım.",
    disposableEmail: "Bu e-posta adresi kabul edilmiyor. Lütfen kalıcı bir adres kullanın.",
    emailAliasExists: "Bu e-posta kutusuna bağlı bir hesap zaten var (aynı adresin noktalı ya da +etiketli hâli). Mevcut adresinizle giriş yapın.",
    tooManySignups: "Bu ağdan bugün çok fazla hesap açılmaya çalışıldı. Lütfen daha sonra tekrar deneyin.",
    accountNotFound: "Bu e-postaya bağlı bir hesap yok ya da kaydın süresi doldu. Yeniden deneyin.",
    secureGateway: "Güvenli Organizatör Girişi",
  },

  // ─── Dashboard ─────────────────────────────────────
  dashboard: {
    title: "Dashboard",
    totalGuests: "Toplam Misafir",
    attending: "Katılıyor",
    people: "kişi",
    maybe: "Belki",
    notAttending: "Katılamıyor",
    pendingMedia: "Onay Bekleyen Medya",
    approvedMedia: "Onaylı Medya",
    welcomeBack: "Hoş geldiniz,",
    activityFeed: "Son Etkinlikler",
    quickActions: "Hızlı Erişim",
    daysLeft: "gün kaldı",
    weddingPast: "Ne güzel bir gündü!",
    inviteLink: "Davet Linki",
    inviteLinkHint: "Misafirlerin düğününüze katılması için bu linki paylaşın.",
    copied: "Kopyalandı!",
    eventStatus: "Etkinlik Durumu",
    statusOn: "Açık",
    statusOff: "Kapalı",
    statusScheduled: "Zamanlanmış",
    recentMedia: "Son Fotoğraflar",
    noMediaYet: "Henüz onaylı fotoğraf yok",
    capacityUsed: "Kapasite doluluk oranı",
    pendingAlert: "fotoğraf inceleme bekliyor",
    pendingAlertSub: "Moderasyon kuyruğunu aç",
    quickGuestsSub: "Misafir listesini yönet",
    quickModerationSub: "Bekleyen yüklemeleri incele",
    quickGallerySub: "Onaylı medyayı görüntüle",
    quickSettingsSub: "Düğün ayarları",
    noActivity: "Henüz etkinlik yok",
    qrFunnelTitle: "QR Hunisi",
    qrScans: "Taramalar",
    qrRegistrations: "Kayıtlar",
    qrConversion: "Dönüşüm",
    qrFunnelEmpty: "Henüz tarama yok — QR kodunu paylaş",
    qrFunnelDetail: "Detay",
  },

  // ─── QR Analytics ──────────────────────────────────
  analytics: {
    title: "QR Analitik",
    summary: "Özet",
    scans: "Taramalar",
    unique: "Benzersiz",
    registrations: "Kayıtlar",
    conversion: "Dönüşüm",
    byDay: "Zaman",
    byDevice: "Cihaz",
    byLocation: "Konum",
    funnel: "Huni",
    unknown: "Bilinmeyen",
    exportCsv: "CSV indir",
    empty: "Henüz tarama yok — QR kodunu paylaş",
    csvOk: "CSV indirildi",
    csvErr: "İndirme başarısız",
    peak: "En yüksek",
    share: "pay",
    deviceMobile: "Mobil",
    deviceTablet: "Tablet",
    deviceDesktop: "Masaüstü",
    refresh: "Yenile",
    exportPdf: "Rapor indir",
    reportTitle: "QR Analitik Raporu",
    peakDay: "En yoğun gün",
    generatedAt: "Oluşturulma",
    pdfOk: "Rapor indirildi",
    pdfErr: "Rapor oluşturulamadı",
  },

  // ─── Guests ────────────────────────────────────────
  guests: {
    title: "Misafirler",
    titleCount: "Misafirler ({{count}})",
    phoneRequired: "Telefon *",
    namePlaceholder: "Ali Veli",
    importBtn: "İçe Aktar",
    exportBtn: "Dışa Aktar",
    jsonFormat: "JSON formatı:",
    columnPhone: "Telefon",
    columnName: "İsim",
    columnRsvp: "RSVP",
    columnHeadcount: "Kişi",
    columnDiet: "Diyet",
    columnNotes: "Notlar",
    columnEditedBy: "Düzenleyen",
    columnDate: "Kayıt",
    dietNone: "Yok",
    dietVegan: "Vegan",
    dietVegetarian: "Vejeteryan",
    dietGlutenFree: "Glutensiz",
    dietOther: "Diğer",
    deleteConfirm: '"{{name}}" misafirini silmek istediğinize emin misiniz?',
    importSuccess: "{{imported}} misafir eklendi, {{skipped}} atlandı (toplam: {{total}})",
    importJsonError: "JSON dosyası bir dizi veya { guests: [...] } formatında olmalı",
    added: "Misafir eklendi",
    deleted: "Misafir silindi",
    deleteNoMedia: "Misafir listeden çıkarılacak. Yüklediği medya yok.",
    deleteMediaKept: "Misafir listeden çıkarılacak. {{count}} medyası galeride KALIR — silmek isterseniz aşağıdaki kutuyu işaretleyin.",
    deleteMediaToo: "{{count}} medyasını da sil",
    deleteMediaTooHint: "Silinen medya {{days}} gün boyunca Moderasyon → Silinenler sekmesinden geri alınabilir, sonra kalıcı olarak silinir.",
    saved: "Değişiklikler kaydedildi",
    exported: "{{count}} misafir dışa aktarıldı",
    phoneHint: "Ülke koduyla birlikte girin — örn. +905551234567",
    phoneInvalid: "Geçersiz numara — ülke kodu ile giriniz (örn. +90...)",
    nameRequired: "İsim zorunludur",
    banGuest: "Misafiri Banla",
    smsConsentOn: "SMS rızası var — kaldırmak için tıkla",
    smsConsentOff: "SMS rızası yok — eklemek için tıkla",
    smsOptedOut: "Misafir SMS almayı reddetti",
    smsConsentSet: "SMS rızası eklendi",
    smsConsentUnset: "SMS rızası kaldırıldı",
    banDuration1d: "1 Gün",
    banDuration7d: "7 Gün",
    banDuration30d: "30 Gün",
    banReasonPlaceholder: "Gerekçe (opsiyonel)",
    banPermanent: "Kalıcı",
    banUntil: "Banlı — {{date}} kadar",
    banPermanentLabel: "Kalıcı Banlı",
    unban: "Banı Kaldır",
    banned: "Banlı",
    guestBanned: "Misafir banlandı",
    guestUnbanned: "Ban kaldırıldı",
    addGuest: "Misafir Ekle",
    editTitle: "Misafiri Düzenle",
    filterAll: "Tümü",
    filterNone: "RSVP Yok",
    rsvpYes: "Katılıyor",
    rsvpNo: "Katılmıyor",
    rsvpMaybe: "Belki",
    rsvpYesCount: "{{count}} kişi katılıyor",
    rsvpNoCount: "{{count}} kişi katılmıyor",
    rsvpMaybeCount: "{{count}} kişi belki",
    noGuests: "Henüz misafir yok",
    noGuestsSearch: "Arama kriterlerine uyan misafir bulunamadı",
    noName: "İsim yok",
    searchPlaceholder: "İsim veya telefon ile ara…",
    columnDetails: "Detaylar",
    headcountLabel: "{{count}} kişi",
    headcountMax: "Maks. {{max}}",
    headcountPerson: "kişi",
    timeMinutes: "{{count}}dk",
    timeHours: "{{count}}sa",
    timeDays: "{{count}}g",
    diet_vegan: "Vegan",
    diet_vegetarian: "Vejetaryen",
    diet_gluten_free: "Glutensiz",
    diet_other: "Özel diyet",
  },

  // ─── Moderation ────────────────────────────────────
  moderation: {
    title: "Medya Moderasyonu",
    titleCount: "Medya Moderasyonu ({{count}} bekliyor)",
    noItems: "Onay bekleyen medya yok",
    approve: "Onayla",
    reject: "Reddet",
    reviewedBy: "Onaylayan: {{email}}",
    history: "Geçmiş",
    pending: "Bekleyenler",
    returnToPending: "Tekrar İncele",
    autoRefreshOff: "Otomatik yenileme kapalı",
    refreshNow: "Yenile",
    autoRefreshOn: "Otomatik yenileme açık ({{s}}s)",
    bulkApprove: "Seçilenleri Onayla",
    bulkReject: "Seçilenleri Reddet",
    bulkApproved: "Seçilen öğeler onaylandı",
    bulkRejected: "Seçilen öğeler reddedildi",
    rejectDeleteHint: "Reddedildi — dosya 7 gün içinde kalıcı olarak silinecek",
    bulkRejectedDeleteHint: "Reddedildi — dosyalar 7 gün içinde kalıcı olarak silinecek",
    deletesIn: "{{days}} günde silinir",
    deletesInHours: "{{hours}} saatte silinir",
    deletesImminently: "Az kaldı, silinecek",
    selected: "{{count}} seçili",
    selectAll: "Tümünü seç",
    deselectAll: "Seçimi kaldır",
    tabApproved: "Onaylananlar",
    tabRejected: "Reddedilenler",
    tabDeleted: "Silinenler",
    noDeleted: "Silinen medya yok",
    deletedHint: "Bu medyalar {{days}} gün içinde kalıcı olarak silinecek. Geri al'a basarak kurtarabilirsiniz.",
    restore: "Geri al",
    guestRemovedLocked: "Misafir kaldırdı",
    guestRemovedLockedHint: "Misafir bu içeriği kendisi kaldırdı. Karar misafirindir: geri alınamaz, onaylanamaz; süre dolunca kalıcı olarak silinir.",
    restored: "Medya geri alındı",
    guestDeleted: "silinmiş misafir",
    unknownGuest: "Bilinmeyen misafir",
  },

  // ─── Wedding CRUD ──────────────────────────────────
  wedding: {
    title: "Düğünler",
    myWeddings: "Düğünlerim",
    newWedding: "Yeni Düğün",
    createTitle: "Yeni Düğün Oluştur",
    slugPlaceholder: "URL slug (ör: mert-gokben)",
    titlePlaceholder: "Düğün başlığı",
    datePlaceholder: "Tarih ve saat",
    locationPlaceholder: "Konum",
    created: "Düğün oluşturuldu",
    createFailed: "Düğün oluşturulamadı",
    deleteConfirm: '"{{slug}}" düğününü silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    deleteFailed: "Silinemedi",
    deleteButton: "Düğünü sil",
    archiveConfirm: '"{{slug}}" düğününü arşivlemek istediğinize emin misiniz? Düğün listenizden kaldırılır ancak veriler korunur ve plan limitinizi etkilemeye devam eder.',
    archived: "Düğün arşivlendi",
    archiveFailed: "Arşivlenemedi",
    archiveButton: "Düğünü arşivle",
    unarchived: "Düğün geri alındı",
    unarchiveFailed: "Geri alınamadı",
    unarchiveButton: "Arşivden çıkar",
    archivedSection: "Arşivlenen düğünler",
    archivedBadge: "Arşivlendi",
    noWeddings: "Henüz düğününüz bulunmuyor.",
    noWeddingsHint: 'Yukarıdaki "Yeni Düğün" butonuyla ilk düğününüzü oluşturun.',
    notFound: "Düğün Bulunamadı",
    noWeddingsAdmin: "Henüz düğün oluşturulmamış",
    owner: "Sahip",
    enterTitle: "Düğün için başlık giriniz",
    enterDate: "Düğün tarih ve saati giriniz",
    enterLocation: "Düğün konumu giriniz",
    descriptionPlaceholder: "Açıklama (isteğe bağlı)",
    infoTab: "Düğün Bilgileri",
    registrationTab: "Kayıt Ayarları",
    bgTab: "Arka Planlar",
    notificationsTab: "Bildirimler",
    slugReadOnly: "Slug değiştirilemez",
    settingsHint: "Düğün bilgilerinizi ve katılım ayarlarını yönetin.",
    updateSuccess: "Düğün bilgileri güncellendi",
    updateFailed: "Güncelleme başarısız",
    eventDateLocked: "Etkinlik tarihi geçti — tarih artık değiştirilemez (paket tek etkinlik içindir). Düzeltme gerekiyorsa destekle iletişime geçin.",
    mainEventLabel: "Düğün",
    event2: {
      sectionTitle: "İkinci Etkinlik",
      sectionHint: "Kına, nikah ya da after-party gibi ek bir etkinliğiniz varsa buradan ekleyin.",
      addButton: "İkinci Etkinlik Ekle",
      removeButton: "Kaldır",
      dateTimeLabel: "Tarih ve Saat",
      locationLabel: "Yer",
      locationPlaceholder: "Mekan adı veya adres",
      labelLabel: "Etkinlik Türü",
      customLabelPlaceholder: "Etkinlik adını yazın",
      dateRequired: "İkinci etkinlik için tarih ve saat zorunlu",
      customLabelRequired: "'Diğer' seçildiğinde etkinlik adı zorunlu",
    },
    program: {
      programTitle: "Program",
      daysLeft: "{{count}} GÜN KALDI",
      today: "BUGÜN",
      past: "GERÇEKLEŞTİ",
      tomorrow: "YARIN",
      mainEventTypeLabel: "Ana Etkinliğin Türü",
    },
    event2Label: {
      kina: "Kına",
      nikah: "Nikah",
      dugun: "Düğün",
      afterParty: "After Party",
      other: "Diğer",
    },
    bgSectionTitle: "Arka Plan Görselleri",
    bgSlotAuth: "Misafir Giriş Arka Planı",
    bgSlotCountdown: "Geri Sayım Arka Planı",
    bgSlotRsvp: "RSVP Arka Planı",
    bgUploaded: "Arka plan yüklendi",
    bgDeleted: "Arka plan silindi",
    bgUploadFailed: "Yükleme başarısız",
    bgDeleteFailed: "Silme başarısız",
    language: "Misafir Uygulaması Dili",
    languageHint: "Misafir giriş sayfasındaki varsayılan ülke kodunu belirler.",
    languageSaved: "Dil kaydedildi",
    languageSaveFailed: "Dil kaydedilemedi",
    bride: "Gelin",
    groom: "Damat",
    enterBride: "Gelin adını giriniz",
    enterGroom: "Damat adını giriniz",
    manage: "Yönet",
    slugAvailable: "Müsait",
    slugTaken: "Kullanımda",
    slugChecking: "Kontrol ediliyor...",
    slugInvalidFormat: "Geçersiz (min. 3, sadece a-z 0-9 tire)",
    nameLettersOnly: "Sadece harf kullanabilirsiniz",
    locationInvalid: "Geçersiz karakter içeriyor",
    pkgWithGuests: "{{plan}} · {{n}} misafire kadar",
    pkgTrial: "{{plan}} (deneme) · {{n}} misafir",
    pkgAccountWide: "{{plan}} · hesap geneli · {{n}} misafir",
    createAccountWideNotice: "Bu düğün paketsiz açılır ve hesabınızın {{plan}} planını kullanır ({{n}} misafire kadar).",
    applyTo: "Düğün seçin",
    applyButton: "Bu düğüne tanımla",
    applied: "Paket “{{title}}” düğününe tanımlandı.",
    applyFailed: "Paket tanımlanamadı, lütfen tekrar deneyin.",
    packageUnavailable: "Bu paket artık kullanılamıyor (başka bir düğüne tanımlanmış olabilir). Liste yenilendi.",
    packageForWedding: "Bu düğünün paketi",
    packageChoiceHint: "Her paket tek düğün içindir; düğünün limitleri seçtiğiniz paketin limitleridir.",
    freeSlotsFull: "Kullanılabilir paketiniz yok. Yeni düğün için paket alın.",
    createdWithPackage: "Düğün oluşturuldu ve paketiniz bu düğüne tanımlandı.",
    pkgFree: "{{plan}} · {{n}} misafir",
    pkgLegacy: "{{plan}} (geçiş) · {{n}} misafir",
    pkgSuspended: "Paket yok — düğün askıda",
    walletAvailable: "Kullanılabilir paketler",
    walletNone: "Yok",
    walletInUse: "Kullanımda: {{n}}",
    walletPending: "Ödeme bekleyen: {{n}}",
    walletLink: "Paketlerim →",
    buyPackage: "Paket al",
    noPackageHint: "Yeni düğün için kullanılabilir paketiniz yok. Paket alın; ödemeniz onaylanınca burada görünür.",
    packagePendingOption: "{{pkg}} · {{number}} — ödeme bekleniyor",
    createFreeNotice: "Bu düğün {{plan}} paketiyle açılır ({{n}} misafire kadar). Sonra ücretli bir paket tanımlayarak yükseltebilirsiniz; Free paket o zaman tükenir.",
    startConsent: "Hizmetin cayma süresi dolmadan hemen başlamasını onaylıyorum; paket bu düğüne tanımlandıktan sonra cayma hakkımın olmadığını biliyorum.",
    packageRequired: "Bu düğün için bir paket seçin.",
    consentRequired: "Ücretli paket için onay kutusunu işaretleyin.",
    upgradeTitle: "Kullanılabilir paketinizi bir düğüne tanımlayın",
    upgradeHint: "Ücretli paket, Free ya da geçiş paketli düğünü yükseltir (Free paket o zaman tükenir). Tanımlandıktan sonra değiştirmek için destekle iletişime geçin.",
    alreadyPaid: "Bu düğüne zaten ücretli bir paket tanımlı.",
    weddingHasPackage: "Free paket yalnız paketi olmayan (askıdaki) bir düğüne tanımlanabilir.",
  },

  // ─── Profile ───────────────────────────────────────
  profile: {
    title: "Profilim",
    emailLabel: "E-posta",
    nameLabel: "Ad Soyad",
    phoneLabel: "Telefon",
    phoneLocked: "Telefon numaranızı değiştirmek için destek hattına yazın.",
    memberSince: "Üye: {{date}}",
    loadFailed: "Profil yüklenemedi",
    updateSuccess: "Profil güncellendi",
    updateFailed: "Güncelleme başarısız",
    deactivateTitle: "Hesabı Devre Dışı Bırak",
    deactivateDesc: "Hesabınız askıya alınacak. Tekrar OTP ile giriş yaptığınızda otomatik olarak aktive olur.",
    deactivateConfirm: "Evet, Devre Dışı Bırak",
    deactivateSuccess: "Hesabınız devre dışı bırakıldı. Yönlendiriliyorsunuz...",
    deactivateFailed: "Hesap devre dışı bırakılamadı",
    dangerZone: "Tehlikeli Bölge",
    accountInfo: "Hesap Bilgileri",
    phoneChangeTitle: "Telefon Numarası Değişikliği",
    phoneChangeAction: "Değiştir",
    phoneVerified: "Doğrulandı",
    phoneNotVerified: "Doğrulanmadı (test SMS için gerekli)",
    phoneVerifyAction: "Doğrula",
    phoneVerifyTitle: "Telefonu doğrula",
    phoneVerifyInfo: "{{phone}} numarasına gönderilen 6 haneli kodu girin.",
    phoneVerifyResend: "Tekrar gönder",
    phoneVerifySubmit: "Doğrula",
    phoneVerifySuccess: "Telefon doğrulandı",
    phoneChangeInfo: "Telefon numaranızı değiştirmek için bir talep oluşturulacak. Ekibimiz en kısa sürede işleme alacak.",
    phoneChangeSubject: "Telefon numarası değişikliği talebi",
    phoneCurrent: "Mevcut",
    phoneChangeNew: "Yeni",
    phoneNone: "Yok",
    phoneChangeAutoNote: "Bu talep profil sayfasından otomatik oluşturulmuştur.",
    phoneChangeSubmit: "Talep Gönder",
    phoneChangeSuccess: "Talebiniz iletildi",
    phoneChangeSuccessDesc: "Ekibimiz numaranızı doğrulayıp en kısa sürede güncelliyecek.",
    phoneChangeViewTicket: "Talebi Görüntüle",
    phoneChangeFailed: "Talep gönderilemedi",
    phoneChangeRequired: "Yeni numara giriniz",
    phoneChangeFormat: "Numara +ülkekodu ile başlamalı (örn. +905551234567)",
    phoneChangeSame: "Yeni numara mevcut numarayla aynı",
    accountPackages: "Hesap ve paketler",
    packagesExplain: "Her düğün bir pakete bağlıdır. Hesabınızın bir Free paketi vardır; her ödenmiş sipariş yeni bir pakettir. Paketleriniz ve sipariş geçmişiniz Paketlerim'de.",
    accountWideBadge: "Hesap geneli: {{plan}}",
    accountWideTitle: "Hesap geneli plan",
    accountWideExplain: "Hesabınıza özel {{plan}} planı, paket tanımlanmamış düğünlerinize uygulanır. Ödenmiş paketler tek düğün içindir ve o düğünün limitlerini belirler.",
    orderLegacy: "Geçiş (eski hesap planı)",
    myOrders: "Siparişlerim",
    noOrders: "Henüz siparişiniz yok.",
    orderPkg: "{{plan}} · {{n}} misafire kadar",
    orderWedding: "Düğün: {{title}}",
    orderCancelled: "İptal edildi",
    orderStatus: {
      pending: "Ödeme bekliyor",
      paid: "Ödendi",
      cancelled: "İptal",
    },
    buyPackage: "Yeni düğün için paket al",
    freeTitle: "Free paket",
    freeStatus: {
      available: "Kullanılabilir — yeni düğün açabilirsiniz",
      assigned: "Kullanımda: {{title}}",
      ended: "Tükendi — düğün ücretli pakete yükseltildi",
      used: "Kullanıldı",
    },
    packagesLink: "Paketlerim",
  },

  // ─── RSVP ──────────────────────────────────────────
  rsvp: {
    title: "RSVP",
    welcomeGuest: "Hoş geldiniz, {{name}}",
    shareStatus: "Katılım durumunuzu bildirin",
    formTitle: "Katılım Formu",
    formDescUpdate: "Bilgilerinizi güncelleyebilirsiniz",
    formDescNew: "Lütfen bilgilerinizi doldurun",
    statusLabel: "Katılım Durumu",
    statusYes: "Katılıyorum",
    statusMaybe: "Belki",
    statusNo: "Katılamıyorum",
    headcountLabel: "Kişi Sayısı",
    decreaseHeadcount: "Kişi sayısını azalt",
    increaseHeadcount: "Kişi sayısını artır",
    dietLabel: "Diyet Tercihi",
    dietNone: "Kısıtlama yok",
    dietVegan: "Vegan",
    dietVegetarian: "Vejeteryan",
    dietGlutenFree: "Glutensiz",
    dietOther: "Diğer",
    notesLabel: "Notlar (opsiyonel)",
    notesPlaceholder: "Herhangi bir mesajınız varsa...",
    submitting: "Gönderiliyor...",
    saved: "Kaydedildi!",
    update: "Güncelle",
    submit: "Gönder",
    successUpdate: "Cevabınız başarıyla güncellendi!",
    successNew: "Cevabınız başarıyla gönderildi!",
    thanks: "Teşekkür ederiz",
  },

  // ─── Media / Upload ────────────────────────────────
  media: {
    uploadTitle: "Fotoğraf / Video Yükle",
    uploadDesc: "Anılarınızı bizimle paylaşın",
    heicLocationNote: "Fotoğraflardaki konum bilgisi yüklemeden önce silinir; ancak HEIC biçimindeki fotoğraflarda bu yapılamıyor. Konumunuzun görünmesini istemiyorsanız fotoğrafı JPEG olarak seçin ya da kamerada konumu kapatın.",
    uploadCard: "Medya Yükle",
    supportedFormats: "JPEG, PNG, HEIC, MP4, MOV dosyaları desteklenir",
    selectFile: "Dosya seçin veya fotoğraf çekin",
    preview: "Önizleme",
    uploadBtn: "Yükle",
    unsupportedType: "Desteklenmeyen dosya türü",
    fileTooLarge: "Dosya çok büyük (maks. {{max}} MB)",
    uploadFailed: "Dosya yüklenemedi",
    uploadPartialError: "Bazı dosyalar yüklenemedi.",
    retryFailed: "Tekrar dene",
    errorTooLarge: "{{name}} çok büyük (maks. {{limit}} MB)",
    errorUnsupportedType: "{{name}} desteklenmiyor (JPEG, PNG, HEIC, MP4, MOV)",
    videoLongWarning: "{{name}} yaklaşık {{duration}} saniye — uzun videolar zayıf bağlantıda yüklenirken sorun çıkarabilir, kısa tutmanız önerilir.",
    dropzoneDesc: "JPEG, PNG, HEIC, MP4, MOV desteklenir",
    dropzone: "Dosya seçin veya fotoğraf çekin",
    uploading: "Yükleniyor... ({{progress}}%)",
    uploadSuccess: "Yüklendi! Moderasyon sonrası görünecektir.",
    moderationNotice: "Yüklediğiniz içerikler galeriye eklenmeden önce onaylanacaktır.",
    uploadTips: "Yükleme İpuçları",
    tip1: "Törenden samimi anlar yakalayın",
    tip2: "10-15 saniyelik kısa klipler en iyi sonucu verir",
    tip3: "Yüksek kaliteli fotoğraflar tercih edilir",
    submitBtn: "Galeriye Gönder ({{count}})",
    noFilesSelected: "Henüz dosya seçilmedi",
    clearAll: "Temizle",
    addMore: "Dosya Ekle",
    filesSelected: "Seçilen ({{count}})",
    mine: {
      title: "Yüklemelerim ({{count}})",
      hint: "Yüklediğiniz bir içeriği buradan kaldırabilirsiniz — hemen yayından kalkar, organizatör geri getiremez, 7 gün içinde kalıcı olarak silinir.",
      pending: "Onay bekliyor",
      approved: "Galeride",
      delete: "Sil",
      deleteConfirm: "Bu içerik kaldırılsın mı? Galeriden ve salondaki ekrandan hemen kalkar, organizatör geri getiremez; 7 gün içinde kalıcı olarak silinir.",
      deleted: "Silindi",
      deleteFailed: "Silinemedi: {{error}}",
    },
  },

  // ─── Gallery ───────────────────────────────────────
  gallery: {
    title: "Galeri",
    subtitle: "Paylaşılan anılar",
    empty: "Henüz paylaşılan medya yok",
    emptyHint: "İlk fotoğrafı siz yükleyin!",
    selectedCount: "{{count}} seçili",
    swipeHint: "Gezinmek için kaydırın",
    prev: "Önceki",
    next: "Sonraki",
    close: "Kapat",
    allMedia: "Onaylı Medya",
    favorites: "Favoriler",
    reviewQueue: "Onay Kuyruğu",
    recycle: "Reddedilenler",
    newAlbum: "Yeni Albüm",
    albumName: "Albüm adı",
    createAlbum: "Albüm oluştur",
    deleteAlbum: "Albümü sil",
    deleteAlbumConfirm: "Bu albümü silmek istediğinizden emin misiniz? İçindeki medyalar silinmez.",
    renameAlbum: "Yeniden adlandır",
    addToAlbum: "Albüme ekle",
    removeFromAlbum: "Albümden çıkar",
    setCover: "Kapak yap",
    selectMode: "Seçim modu",
    cancelSelect: "Seçimi iptal et",
    selected: "{{count}} seçili",
    albumLimitReached: "Maksimum 5 özel albüm oluşturabilirsiniz.",
    onlyApprovedCanBeAdded: "Sadece onaylı medyalar albüme eklenebilir.",
    noMedia: "Henüz medya yok.",
    noAlbumMedia: "Bu albümde henüz medya yok.",
    loadMore: "Daha fazla yükle",
    itemCount: "{{count}} öğe",
    addedToFavorites: "Favorilere eklendi",
    removedFromFavorites: "Favorilerden çıkarıldı",
    addedToAlbum: "Albüme eklendi",
    removedFromAlbum: "Albümden çıkarıldı",
    albumCreated: "Albüm oluşturuldu",
    albumDeleted: "Albüm silindi",
    albumRenamed: "Albüm yeniden adlandırıldı",
    coverSet: "Kapak fotoğrafı güncellendi",
    like: "Beğen",
    unlike: "Beğeniyi kaldır",
    liked: "Beğenildi!",
    commentAdded: "Yorum eklendi",
    commentDeleted: "Yorum silindi",
    deleteComment: "Yorumu sil",
    noComments: "Henüz yorum yok",
    commentPlaceholder: "Yorum ekle...",
    share: "Paylaş",
    viewAllComments: "Tüm {{count}} yorumu gör",
    likesCount: "{{count}} beğeni",
    guest: "Misafir",
    doubleTapToLike: "Beğenmek için çift dokun",
    uploadPhotos: "Yükle",
    searchByName: "Misafir adına göre ara...",
    filterNewest: "En Yeni",
    filterOldest: "En Eski",
    download: "İndir",
    commentsCount: "{{count}} yorum",
    uploadedBy: "{{name}} tarafından yüklendi",
    noResults: "Sonuç bulunamadı",
    noResultsHint: "Farklı bir arama terimi deneyin",
    albums: "Albümler",
    noAlbums: "Albüm yok",
    noPublicAlbums: "Henüz paylaşılmış albüm yok",
    noPublicAlbumsHint: "Organizatör henüz albüm yayınlamadı",
    backToAlbums: "Albümlere Dön",
    makePublic: "Herkese Açık Yap",
    makePrivate: "Gizli Yap",
    filterAll: "Tümü",
    filterPhotos: "Fotoğraflar",
    filterVideos: "Videolar",
    manageAlbums: "Albümleri Yönet",
    editAlbum: "Albümü Düzenle",
    hideComment: "Yorumu Gizle",
    unhideComment: "Yorumu Göster",
    commentHidden: "Gizlendi",
    commentHiddenSuccess: "Yorum gizlendi",
    commentUnhiddenSuccess: "Yorum görünür yapıldı",
    visibility: "Görünürlük",
    coverPhoto: "Kapak Fotoğrafı",
    public: "Herkese Açık",
    private: "Gizli",
    albumSaved: "Albüm kaydedildi",
    addFromGallery: "Galeriden Ekle",
    addSelected: "Seçilenleri Ekle ({{count}})",
    alreadyInAlbum: "Zaten albümde",
    removeFromAlbumConfirm: "Çıkar?",
    searchGuest: "Misafir ara...",
  },

  // ─── Activity Feed ──────────────────────────────
  activity: {
    title: "Aktivite",
    all: "Tümü",
    reactions: "Tepkiler",
    uploads: "Yüklemeler",
    likedOne: "bir fotoğrafı beğendi",
    likedOne_video: "bir videoyu beğendi",
    likedMany: "{{count}} fotoğrafı beğendi",
    likedMany_video: "{{count}} videoyu beğendi",
    commentedOne: "yorum yaptı",
    commentedMany: "{{count}} yorum yaptı",
    uploadedOne: "bir fotoğraf yükledi",
    uploadedOne_video: "bir video yükledi",
    uploadedMany: "{{count}} fotoğraf yükledi",
    uploadedMany_video: "{{count}} video yükledi",
    pendingOne: "1 fotoğrafınız onay bekliyor",
    pendingMany: "{{count}} fotoğrafınız onay bekliyor",
    newActivity: "{{count}} yeni aktivite",
    empty: "Henüz aktivite yok",
    emptyHint: "İlk fotoğrafı yükleyen siz olun!",
    justNow: "az önce",
    minutesAgo: "{{count}}d önce",
    hoursAgo: "{{count}}s önce",
    daysAgo: "{{count}}g önce",
    you: "Siz",
    uploaded: "bir fotoğraf yükledi",
    uploaded_video: "bir video yükledi",
    liked: "fotoğrafını beğendi",
    liked_video: "videosunu beğendi",
    commented: "yorum yaptı",
    youUploadedOne: "bir fotoğraf yüklediniz",
    youUploadedOne_video: "bir video yüklediniz",
    youUploadedMany: "{{count}} fotoğraf yüklediniz",
    youUploadedMany_video: "{{count}} video yüklediniz",
    youLikedOne: "bir fotoğrafı beğendiniz",
    youLikedOne_video: "bir videoyu beğendiniz",
    youLikedMany: "{{count}} fotoğrafı beğendiniz",
    youLikedMany_video: "{{count}} videoyu beğendiniz",
    youCommentedOne: "yorum yaptınız",
    youCommentedMany: "{{count}} yorum yaptınız",
    unknownGuest: "Misafir",
    galleryBanner: "{{count}} yeni etkinlik ↑",
    galleryBannerTap: "Görmek için dokun",
    toast: {
      newUpload: "{{name}} bir fotoğraf yükledi 📸",
      newUpload_video: "{{name}} bir video yükledi 🎥",
      newLike: "{{name}} fotoğrafını beğendi ❤️",
      newLike_video: "{{name}} videosunu beğendi ❤️",
      newComment: "{{name}} yorum yaptı 💬",
      see: "Gör →",
    },
  },

  // ─── Sahne (canlı gösteri) ─────────────────────────
  slideshow: {
    title: "Sahne",
    live: "Canlı",
    connecting: "Bağlanıyor...",
    waiting: "Sahne bekleniyor...",
    waitingHint: "Onaylanan fotoğraflar burada görünecek",
    sharedBy: "{{name}} paylaştı",
    memoriesInSync: "Anılar canlı aktarılıyor",
    fullscreen: "Tam Ekran",
    exit: "Çık",
    exitFullscreen: "Küçült",
    mute: "Sesi kapat",
    unmute: "Sesi aç",
    scanToJoin: "Kutlamaya katıl",
    scanToJoinHint: "Fotoğraf paylaş & kalp gönder",
    tapToReact: "Telefonundan ❤️ gönder",
    reactedOne: "{{name}} tepki verdi",
    reactedOther: "{{name}} +{{count}} tepki verdi",
    idleHint: "İlk anını paylaşmak için kodu okut",
    watching: "izliyor",
    presenceTitle: "Sahnedekiler",
    presenceMore: "+{{count}} kişi daha",
    joined: "{{name}} katıldı",
    rejiLive: "Reji yayında",
    guestFallbackName: "Misafir",
  },

  // ─── Sahne transport (Reji + dashboard paylaşır) ───
  slideshowRemote: {
    playing: "Oynatılıyor",
    paused: "Duraklatıldı",
    slideOf: "{{current}} / {{total}}",
    viewers: "{{count}} izleyici",
    pause: "Duraklat",
    resume: "Devam Et",
    next: "Sonraki",
    previous: "Önceki",
    controlSuccess: "Komut gönderildi",
    controlFailed: "Komut gönderilemedi",
    offline: "Aktif sahne yok",
  },

  // ─── Reji (yönetmen konsolu) ───────────────────────
  reji: {
    title: "Reji",
    subtitle: "Yönetmen Konsolu",
    live: "CANLI",
    idleNoViewers: "İzleyici bekleniyor — sahne beklemede",
    connecting: "Bağlanıyor...",
    watchMode: "Sahneye katıl",
    exitWatch: "Rejiye dön",
    flow: "Akış",
    nowPlaying: "Sahnede",
    nextUp: "Sıradaki",
    hidden: "Gizli",
    hide: "Gizle",
    unhide: "Geri Getir",
    spotlight: "Öne Al",
    gotoSuccess: "Slayta geçildi",
    hideSuccess: "Gösterimden gizlendi",
    unhideSuccess: "Gösterime geri alındı",
    spotlightSuccess: "Öne alındı — sıradaki slayt",
    orderFirst: "Başa Al",
    moveNext: "Sıradaki yap",
    moveEnd: "Sona At",
    nudgeUp: "Yukarı",
    nudgeDown: "Aşağı",
    presenceSheetTitle: "İzleyiciler",
    roleGuest: "Misafir",
    roleReji: "Reji",
    emptyPlaylist: "Henüz onaylanmış medya yok",
    openReji: "Reji'yi Aç",
    dashboardStatus: "Sahne Durumu",
  },

  // ─── Admin ─────────────────────────────────────────
  admin: {
    watchSahne: "Sahne'yi İzle",
    beVisible: "Görünür ol",
    watchHidden: "Gizli izle",
    watchOnly: "Sadece izleme",
    presenceName: "Yönetici",
    forbidden: "Erişim Yetkiniz Yok",
    forbiddenDesc: "adresi platform yöneticisi olarak kayıtlı değil.",
    forbiddenHelp: "Erişim almak için platform yöneticisine başvurun.",
    switchAccount: "Farklı Hesapla Giriş Yap",
    backToWeddings: "Tüm Düğünlere Dön",
    usersTitle: "Kullanıcılar (Organizatörler)",
    usersDesc: "Platform organizatörlerini ve hesap planlarını yönet",
    weddingsDesc: "Platformdaki tüm düğünleri yönet ve izle",
    packageColumn: "Paket",
    packageAccountWide: "hesap geneli",
    packageTrial: "Deneme",
    packageFree: "Free paket",
    packageLegacy: "geçiş",
    packageSuspended: "Askıda (paket yok)",
    accountPlanShort: "Hesap: {{plan}}",
    accountPlanTitle: "Organizatörün hesap planı — yalnız paketsiz (deneme) düğünler için geçerli; bu düğünün paketi panel kartında",
    usersTotal: "Toplam {{count}} organizatör",
    usersEmpty: "Henüz kayıtlı kullanıcı yok.",
    usersLoadFailed: "Kullanıcılar yüklenemedi",
    planUpdateFailed: "Paket güncellenemedi",
    columnPlan: "Paket",
    columnWeddings: "Düğün",
    columnRegistered: "Kayıt",
    userDetail: "Kullanıcı Detayı",
    userWeddings: "Kullanıcının Düğünleri",
    noUserWeddings: "Bu kullanıcının düğünü yok.",
    organizersTitle: "Organizatörler",
    organizersEmpty: "Bu düğüne henüz organizatör atanmamış.",
    organizerRole: "Rol",
    organizerAccessHint: "Bu düğüne erişim yetkisi verilen organizatörler",
    addOrganizer: "Organizatör Ekle",
    addFirstOrganizer: "İlk organizatörü ekle",
    organizerAdded: "Organizatör eklendi",
    organizerRemoved: "Organizatör kaldırıldı",
    removeOrganizer: "Organizatörü Kaldır",
    removeOrganizerConfirm: "adlı organizatörün erişimini kaldırmak istediğinize emin misiniz?",
    // ─── Plans management ───────────────────────────
    plans: "Paketler",
    addPlan: "Yeni Paket",
    auditLog: "Denetim Kaydı",
    planDeleteConfirm: '"{{slug}}" planını silmek istediğinize emin misiniz?',
    planFieldSlug: "Slug",
    planFieldLabel: "Etiket",
    planFieldSortOrder: "Sıra",
    planFieldDefault: "Varsayılan",
    planFieldMaxWeddings: "Max Düğün",
    planFieldMaxGuests: "Max Misafir",
    planFieldMaxStorage: "Max Depolama (GB)",
    planFieldMaxMedia: "Max Medya",
    planColLabel: "Etiket",
    planColSlug: "Slug",
    planColWeddings: "Düğün",
    planColGuests: "Misafir",
    planColStorage: "Depolama",
    planColMedia: "Medya",
    planColUsers: "Kullanıcı",
    planColStatus: "Durum",
    planStatusDefault: "Varsayılan",
    planStatusActive: "Aktif",
    planStatusInactive: "Pasif",
    planHistory: "Geçmiş",
    planChangeHistory: "Değişiklik Geçmişi",
    planNoHistory: "Değişiklik geçmişi yok",
    // ─── Audit log ──────────────────────────────────
    timeJustNow: "az önce",
    timeMinutesAgo: "{{count}} dk önce",
    timeHoursAgo: "{{count}} saat önce",
    timeDaysAgo: "{{count}} gün önce",
    auditDescription: 'Platform genelindeki tüm yazma işlemleri',
    auditFilterAction: 'Aksiyon filtrele',
    auditSearchAction: 'Aksiyon ara…',
    auditRecordCount: '{{count}} kayıt',
    auditTimeJustNow: 'az önce',
    auditTimeMinutes: '{{count}}dk önce',
    auditTimeHours: '{{count}}sa önce',
    auditTimeDays: '{{count}}g önce',
    auditActorAll: "Tüm Aktörler",
    auditActorAdmin: "Admin",
    auditActorOrganizer: "Organizatör",
    auditActorGuest: "Misafir",
    auditActorSystem: "Sistem",
    auditActionsAll: "Tüm İşlemler",
    auditSearchPlaceholder: "Ad, e-posta veya ID ara...",
    auditNoResults: "Kayıt bulunamadı",
    auditColTime: "Zaman",
    auditColActor: "Aktör",
    auditColIdentity: "Kimlik",
    auditColAction: "İşlem",
    auditColResource: "Kaynak",
    auditColWeddingId: "Düğün ID",
    auditGuestPrefix: "Misafir",
    auditLoadMore: "Daha Fazla Yükle",
    auditMetadata: "Metadata",
    auditMetadataNone: "Bu kayıt için metadata bulunmuyor.",
  },

  // ─── Web App ───────────────────────────────────────
  web: {
    notFound: "Düğün Bulunamadı",
    weddingNotFound: "Düğün Bulunamadı",
    notFoundDesc: "Aradığınız düğün sayfası mevcut değil. Lütfen davet linkinizi kontrol edin.",
    invalidSlug: "Lütfen davet linkinizi kullanarak erişin.",
    useLinkPrompt: "Lütfen davet linkinizi kullanarak erişin.",
    appTitle: "Vite Gallery",
    notifications: "Bildirimler",
  },

  // ─── QR Self-Registration (Guest) ──────────────────
  join: {
    title: "Düğüne Katılım Kaydı",
    subtitle: "Bilgilerinizi girerek düğüne katılın",
    namePlaceholder: "Ad Soyad",
    nameLabel: "Ad Soyad",
    submit: "Kaydol",
    submitting: "Kaydediliyor...",
    smsConsentLabel: "Düğüne dair davet ve hatırlatma SMS'leri almak istiyorum. (İstediğiniz zaman mesajdaki linkten çıkabilirsiniz.)",
    alreadyRegistered: "Zaten kaydolmuşsunuz!",
    alreadyRegisteredHint: "Bu telefon numarasıyla düğüne daha önce kayıt oldunuz. Aşağıdaki butona tıklayarak giriş yapabilirsiniz.",
    goToLogin: "Giriş Yap",
    registrationClosed: "Kayıt Kapalı",
    registrationClosedHint: "Bu düğün için misafir kaydı şu an aktif değil",
    registrationNotYet: "Kayıt Henüz Açılmadı",
    registrationOpensWeddingDay: "Düğün gününde aktif olacak",
    countdownDays: "gün",
    countdownHours: "sa",
    countdownMinutes: "dk",
    countdownSeconds: "sn",
    successOtp: "Telefonunuza doğrulama kodu gönderildi",
    successAuthed: "Kaydınız tamamlandı!",
    capReached: "Kayıt Geçici Olarak Durduruldu",
    capReachedHint: "Bugün için kayıt sınırına ulaşıldı. Lütfen daha sonra tekrar deneyin ya da çiftle iletişime geçin.",
    guestLimitReached: "Misafir kotası doldu",
    guestLimitReachedHint: "Bu düğünün misafir kotası doldu. Lütfen düğün sahibine haber verin — kotayı genişletebilirler. Davetliler listesindeyseniz telefonunuzla giriş yapabilirsiniz.",
    foreignNumber: "Bu numarayla kayıt yapılamıyor.",
    foreignNumberHint: "Doğrulama SMS'i yalnız {{prefixes}} ile başlayan numaralara gönderilebiliyor. Lütfen çiftle iletişime geçin, sizi listeye eklesinler.",
    invalidName: "Lütfen adınızı ve soyadınızı yazın — en az 2 harf, rakam ya da bağlantı olmadan.",
  },

  // ─── Registration Settings (Organizer) ─────────────
  registration: {
    title: "Kayıt Ayarları",
    allowSelfRegister: "QR kayıt",
    allowSelfRegisterHint: "Misafirler QR kodu okutarak kendi kendine kayıt olabilir",
    requireOtp: "OTP doğrulama",
    requireOtpHint: "Kapalıysa telefon numarası girişi yeterli, doğrulama kodu gönderilmez",
    closedMode: "Kalıcı olarak kapalı",
    closedModeHint: "Misafirler kayıt yaptıramaz",
    scheduledMode: "Planlı açılış",
    opensAt: "Kayıt açılış zamanı",
    opensAtHint: "Bu tarih ve saatten itibaren kayıt otomatik açılır",
    opensAtRequired: "Lütfen bir açılış tarihi ve saati seçin",
    useWeddingTime: "Düğün saatini kullan",
    closesAt: "Kayıt kapanış zamanı",
    closesAtHint: "Bu tarihten sonra QR linkinden kayıt kabul edilmez. Boş bırakılırsa kayıt açık kalır.",
    closesAtClear: "Temizle",
    closesAtBeforeOpens: "Kapanış zamanı açılış zamanından sonra olmalı",
    closesAtWeekAfterWedding: "Düğünden 1 hafta sonra",
    incentiveTextPlaceholder: "Düğünden sonra fotoğrafları sizinle paylaşabilmek için telefon numaranıza ihtiyacımız var",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    saved: "Ayarlar kaydedildi",
    saveFailed: "Kaydedilemedi",
    qrCode: "QR Kodu",
    qrCodeHint: "Misafirlerin tarayacağı QR kod",
    qrDownload: "PNG İndir",
    qrDownloadSvg: "SVG İndir",
    qrDownloadPdf: "PDF İndir",
    qrCtaShare: "Fotoğraflarını Paylaş",
    qrCopyUrl: "URL Kopyala",
    qrCopied: "Kopyalandı!",
    sourceOrganizer: "Elle eklendi",
    sourceQr: "QR ile katıldı",
    weddingDetails: "Düğün Detayları",
    weddingDetailsHint: "Misafirlerin RSVP sırasında doldurabileceği alanları kontrol edin",
    showDietField: "Diyet tercihi",
    showDietFieldHint: "Misafirlerden diyet kısıtlamalarını toplayın",
    showNotesField: "Özel istekler",
    showNotesFieldHint: "Misafirlerin not eklemesine izin verin",
    maxHeadcount: "RSVP başına kişi sayısı",
    maxHeadcountHint: "Her RSVP yanıtı için maksimum kişi sayısı",
  },

  // ─── Support Tickets ───────────────────────────────
  support: {
    title: "Destek Talepleri",
    newTicket: "Yeni Talep Aç",
    subject: "Konu",
    body: "Açıklama",
    status: "Durum",

    noTickets: "Henüz destek talebiniz bulunmuyor.",
    selectTicket: "Bir ticket seçin",
    selectTicketHint: "ya da yeni bir destek talebi açın",
    statusOpen: "Açık",
    statusInReview: "İnceleniyor",
    statusResolved: "Çözüldü",
    statusClosed: "Kapatıldı",
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    successCreate: "Destek talebiniz iletildi.",
    settingsSaved: "Kaydedildi",
    backToList: "Taleplere Dön",
    weddingLabel: "İlgili Düğün",
    generalTicket: "Genel (düğüne özel değil)",
    minCharsSubject: "Konu en az 5 karakter olmalı",
    minCharsBody: "Açıklama en az 20 karakter olmalı",
    replyPlaceholder: "Mesajınızı yazın...",
    sendMessage: "Gönder",
    sending: "Gönderiliyor...",
    ticketClosed: "Bu ticket kapatıldı, yeni mesaj gönderilemez.",
    you: "Siz",
    admin: "Destek Ekibi",
    unreadDot: "Yeni mesaj",
    priorityLow: "Düşük",
    priorityNormal: "Normal",
    priorityHigh: "Yüksek",
    priorityUrgent: "Acil",
    categoryGeneral: "Genel",
    categoryBilling: "Fatura",
    categoryTechnical: "Teknik",
    categoryBug: "Hata Bildirimi",
    categoryFeatureRequest: "Özellik İsteği",
    priority: "Öncelik",
    category: "Kategori",
    internalNote: "İç Not",
    internalNoteHint: "Bu not yalnızca admin ekibine görünür, organizatöre gösterilmez.",
    sendAndResolve: "Gönder ve Çöz",
    reopen: "Yeniden Aç",
    reopenConfirm: "Bu talep yeniden açılacak. Emin misiniz?",
    csatTitle: "Destek deneyiminizi puanlayın",
    csatHint: "Bu talep çözüldü. Deneyiminizi 1-5 arasında puanlayabilirsiniz.",
    csatSubmit: "Puanla",
    csatThanks: "Geri bildiriminiz için teşekkürler!",
    csatAlreadyRated: "Bu talebi zaten puanladınız.",
    cannedResponses: "Hazır Yanıtlar",
    cannedResponsesEmpty: "Henüz hazır yanıt eklenmemiş.",
    addCannedResponse: "Hazır Yanıt Ekle",
    cannedTitle: "Başlık",
    cannedContent: "İçerik",
    deleteCannedConfirm: "Bu hazır yanıt silinecek. Emin misiniz?",
    insertCanned: "Hazır yanıt ekle",
    attachments: "Ekler",
    attachmentHint: "En fazla 2 fotoğraf, her biri max 5 MB (JPEG, PNG, WebP, GIF)",
    attachmentUploading: "Yükleniyor...",
    attachmentError: "Dosya yüklenemedi",
    removeAttachment: "Eki kaldır",
    ticketNumber: "Talep #{{number}}",
    sendNotification: "Bildirimi gönder",
    noNotification: "Bildirim gönderme",
    monthlyLimitReached: "Aylık talep limitine ulaştınız (maks. 10/ay). Önce açık taleplerinizi çözün.",
    csatRated: "Puanlananlar",
    csatUnrated: "Puan Bekleyenler",
    tabActive: "Aktif",
    tabResolved: "Çözüldü",
    attachFiles: "Dosya ekle",
    fileTypeError: "Yalnızca JPEG, PNG, WebP ve GIF dosyaları desteklenmektedir.",
    fileSizeError: "Her dosya en fazla 5 MB olabilir.",
  },
  adminSupport: {
    title: "Destek Talepleri",
    settings: "Destek Ayarları",
    allTickets: "Tüm Talepler",
    noTickets: "Bekleyen destek talebi yok.",
    from: "Gönderen",
    replyPlaceholder: "Yanıtınızı yazın...",
    saveReply: "Yanıtı Kaydet",
    saving: "Kaydediliyor...",
    updateStatus: "Durumu Güncelle",
    settingsTitle: "Destek Yapılandırması",
    emailLabel: "Bildirim E-posta Adresi",
    sendMessage: "Gönder",
    sending: "Gönderiliyor...",
    unreadDot: "Yeni mesaj",
  },
  sms: {
    title: "SMS Davetleri",
    description: "Misafirlerinize davet ve RSVP hatırlatma SMS'leri gönderin",
    quotaLabel: "Gönderim hakkı",
    quotaExhausted: "Gönderim hakkınız doldu",
    smsQuotaLabel: "SMS Adedi",
    smsQuotaExhausted: "SMS adedi hakkınız doldu",
    channelDisabled: "SMS gönderimi yönetici tarafından geçici olarak devre dışı bırakıldı. Zamanlanmış kampanyalarınız kanal açıldığında otomatik gönderilecek.",
    campaignsDisabled: "SMS kampanyaları yönetici tarafından henüz etkinleştirilmedi. Zamanlanmış kampanyalarınız etkinleştirildiğinde otomatik gönderilecek.",
    sendDisabledHint: "SMS gönderimi yönetici tarafından kapalı — gönderim yapılamaz.",
    newCampaign: "Yeni Kampanya",
    nameLabel: "Kampanya adı",
    namePlaceholder: "ör. İlk davet",
    templateLabel: "Mesaj şablonu",
    defaultTemplate: "Sayın {{guest_name}}, {{date}} tarihinde {{couple_names}} düğün töreninde sizleri aramızda görmekten mutluluk duyarız. Katılım durumunuz için: {{rsvp_link}}",
    previewLabel: "Önizleme",
    previewEmpty: "Mesajınız burada görünecek",
    sampleGuest: "Ayşe Yılmaz",
    segmentInfo: "{{chars}} karakter · {{segments}} SMS segmenti",
    ucs2Hint: "(Türkçe karakterler segment başına 70 karaktere düşürür)",
    segmentLabel: "Kime gönderilecek?",
    segments: {
      all: "Tüm misafirler",
      rsvp_none: "RSVP vermeyenler",
      rsvp_no: "Katılmıyorum diyenler",
      rsvp_maybe: "Kararsızlar",
      manual: "Elle seç",
    },
    recipientCount: "{{count}} alıcı",
    searchGuests: "Misafir ara…",
    selectedCount: "{{count}} seçili",
    noGuests: "Misafir bulunamadı",
    scheduleLabel: "Ne zaman gönderilecek?",
    schedules: {
      now: "Şimdi gönder",
      scheduled: "İleri tarihte",
      auto_chain: "Otomatik hatırlatma",
    },
    scheduledAtLabel: "Gönderim zamanı",
    chainDaysLabel: "Kaç gün arayla?",
    chainRoundsLabel: "En fazla tur",
    chainHint: "Her turda yalnızca hâlâ RSVP vermemiş misafirlere gönderilir; RSVP verenler zincirden otomatik çıkar.",
    testPhonePlaceholder: "+90…",
    sendTest: "Test gönder",
    testHint: "Doğrulanmış numaranıza gider (Profil'den doğrulayın).",
    testDisabledAdminHint: "Adminlerin doğrulanmış bir telefon numarası kaydı yok — test gönderimi burada kullanılamaz.",
    goToControlCenter: "Kontrol merkezine git",
    excludedNoConsent: "{{count}} rıza yok",
    testSent: "Test SMS'i gönderildi",
    costEstimate: "Tahmini maliyet: ~${{cost}}",
    submitNow: "Gönder",
    submitSchedule: "Planla",
    created: "Kampanya oluşturuldu",
    canceled: "Kampanya iptal edildi",
    delete: "Sil",
    deleteConfirm: "Bu kampanya kalıcı olarak silinecek. Emin misiniz?",
    deleted: "Kampanya silindi",
    cancel: "İptal et",
    details: "Detaylar",
    history: "Kampanya Geçmişi",
    noCampaigns: "Henüz kampanya yok. İlk davetinizi yukarıdan gönderin.",
    roundsUsed: "{{count}} tur",
    nextRound: "sıradaki: {{date}}",
    held: "Beklemede",
    // sms_campaigns.hold_reason (migration 045) → organizatörün ANLAYACAĞI dil.
    // Ham enum (not_configured vb.) ASLA ekrana yazılmaz.
    holdBadge: "Beklemede",
    holdReasons: {
      channel_disabled: "SMS gönderimi yönetici tarafından geçici olarak kapatıldığı için beklemede. Kanal açıldığında otomatik gönderilecek.",
      campaigns_disabled: "SMS kampanyaları yönetici tarafından henüz etkinleştirilmediği için beklemede. Etkinleştirildiğinde otomatik gönderilecek.",
      not_configured: "SMS gönderim altyapısı henüz yapılandırılmadığı için beklemede — lütfen yönetici ile iletişime geçin.",
      spend_breaker: "Güvenlik amaçlı harcama sınırı devreye girdiği için beklemede. Yönetici sınırı sıfırladığında otomatik gönderilecek.",
      daily_cap: "Günlük gönderim sınırına ulaşıldığı için beklemede. Sınır sıfırlandığında otomatik gönderilecek.",
    },
    // Admin onay eşiği (migration 047). `holdReasons` ile ORTOGONAL: o platform
    // engellerini, bu tek seferlik insan kararını anlatır.
    approval: {
      pendingBadge: "Onay Bekliyor",
      approvedBadge: "Onaylandı",
      rejectedBadge: "Reddedildi",
      pendingHint: "{{count}} kişilik liste eşiği aştığı için yönetici onayı bekliyor. Onaylanınca otomatik gönderilecek.",
      rejectedHint: "Bu kampanya yönetici tarafından reddedildi; gönderim yapılmayacak. Daha küçük bir segmentle yeni kampanya oluşturabilirsiniz.",
      rejectedHintWithReason: "Yönetici reddetti: {{reason}}",
      createdPending: "Kampanyanız oluşturuldu — {{count}} kişilik liste eşiği aştığı için yönetici onayı bekliyor. Onaylanınca otomatik gönderilecek.",
      // Admin onay kuyruğu sayfası
      pageTitle: "SMS Onayları",
      pageDescription: "Eşiği aşan kampanyalar burada onay bekler — onaylanana kadar tek SMS gitmez.",
      empty: "Onay bekleyen kampanya yok",
      emptyHint: "Alıcı sayısı eşiği aşan her kampanya otomatik olarak buraya düşer.",
      thresholdNote: "Geçerli eşik: {{count}} alıcı. Kontrol Merkezi'nden değiştirilebilir.",
      recipients: "{{count}} alıcı",
      recipientsUnknown: "Alıcı sayısı belirlenemedi (güvenli tarafta onay isteniyor)",
      estimatedCost: "Tahmini maliyet",
      segmentsPerMessage: "Mesaj başına {{count}} segment",
      wedding: "Düğün",
      organizer: "Organizatör",
      createdAt: "Oluşturulma",
      scheduledFor: "Planlanan gönderim",
      sendNowLabel: "Hemen (onay bekleniyor)",
      messagePreview: "Mesaj önizleme",
      approve: "Onayla",
      reject: "Reddet",
      approving: "Onaylanıyor…",
      rejecting: "Reddediliyor…",
      rejectReasonLabel: "Red gerekçesi (opsiyonel)",
      rejectReasonPlaceholder: "Örn. liste fazla büyük, segment daraltılmalı",
      rejectCancel: "Vazgeç",
      rejectConfirm: "Reddet",
      approveSuccess: "Kampanya onaylandı — gönderim serbest bırakıldı.",
      rejectSuccess: "Kampanya reddedildi — gönderim yapılmayacak.",
      actionError: "İşlem tamamlanamadı",
      loadMore: "Daha fazla yükle",
    },
    round: "Tur {{n}}",
    noSendsYet: "Henüz gönderim yapılmadı.",
    center: {
      pageTitle: "SMS Merkezi",
      pageDescription: "Tüm düğünlerin SMS kampanyaları: onay kuyruğu ve gerçekleşen harcama.",
      tabPending: "Onay Bekleyenler",
      tabAll: "Tüm Kampanyalar",
      filterWedding: "Düğün",
      filterWeddingAll: "Tüm düğünler",
      filterStatus: "Durum",
      filterStatusAll: "Tüm durumlar",
      filterApproval: "Onay",
      filterApprovalAll: "Tüm onay durumları",
      filterApprovalNone: "Onaya girmedi",
      filterIncludeDeleted: "Silinenleri göster",
      filterReset: "Filtreleri temizle",
      pageTotals: "Bu sayfada {{count}} kampanya · {{segments}} segment · ~${{usd}}",
      empty: "Kampanya yok",
      emptyHint: "Henüz hiçbir düğünde SMS kampanyası oluşturulmadı.",
      emptyFiltered: "Seçtiğiniz filtrelere uyan kampanya yok.",
      deletedBadge: "Silindi",
      spent: "Harcama",
      segmentsUsed: "{{count}} segment",
      sends: "Gönderim",
      deliveredFailed: "{{delivered}} teslim · {{failed}} hata",
      audience: "Kitle",
      lastDispatch: "Son gönderim",
      nextDispatch: "Sıradaki: {{at}}",
      rejectionReason: "Red gerekçesi: {{reason}}",
      createdAt: "Oluşturuldu: {{at}}",
      unitPrice: "birim ${{usd}}",
    },
    status: {
      scheduled: "Planlandı",
      active: "Aktif",
      dispatching: "Gönderiliyor",
      completed: "Tamamlandı",
      canceled: "İptal",
      failed: "Hata",
    },
    sendStatus: {
      queued: "Sırada",
      sent: "Gönderildi",
      delivered: "Ulaştı",
      failed: "Başarısız",
      undelivered: "Ulaşmadı",
    },
    table: {
      guest: "Misafir",
      phone: "Telefon",
      round: "Tur",
      status: "Durum",
    },
  },

  errorBoundary: {
    title: "Bu sayfa açılırken bir sorun oldu",
    desc: "Diğer sayfalar çalışmaya devam ediyor. Sayfayı yeniden yükleyin; sorun sürerse ayrıntıyı bize iletin.",
    reload: "Sayfayı yeniden yükle",
    details: "Teknik ayrıntı",
  },
  controlCenter: {
    loadPartialFailed: "{{count}} veri kaynağı yüklenemedi — gösterilenler eksik olabilir.",
    accountsPrivacy: {
      title: "Hesaplar ve gizlilik",
    },
    title: "Kontrol Merkezi",
    description: "Kill switch'ler, finansal limitler, SMS harcaması ve gönderim kayıtları",
    type: "Tip",
    killSwitch: "Kill Switch",
    group: {
      sms: "SMS",
      other: "Diğer",
    },
    smsEnabled: "SMS Ana Kesici",
    smsEnabledDesc: "Kampanya + OTP dahil her SMS'i durdurur (ana kesici).",
    emailEnabled: "E-posta Ana Kesici",
    emailEnabledDesc: "Tüm e-posta gönderimi (OTP, uyarılar, destek).",
    smsCampaignsEnabled: "SMS Kampanya",
    smsCampaignsDesc: "Davet/hatırlatma SMS'leri; girişi (OTP) etkilemez.",
    masterBadge: "TÜMÜ",
    enabled: "Aktif",
    disabled: "Devre Dışı",
    configSaved: "Yapılandırma kaydedildi",
    stats: "İstatistikler",
    sms24h: "SMS (24s)",
    email24h: "E-posta (24s)",
    failed24h: "Başarısız (24s)",
    blocked24h: "Engellendi (24s)",
    sms7d: "SMS (7g)",
    email7d: "E-posta (7g)",
    logs: "Gönderim Günlüğü",
    recipient: "Alıcı",
    status: "Durum",
    error: "Hata",
    weddingId: "Düğün",
    createdAt: "Tarih",
    noLogs: "Kayıt bulunamadı.",
    loadMore: "Daha Fazla",
    filters: {
      all: "Tümü",
      sms: "SMS",
      email: "E-posta",
      sent: "Gönderildi",
      failed: "Başarısız",
      blocked: "Engellendi",
    },
    campaigns: {
      title: "SMS Kampanyaları",
      active: "Aktif Kampanya",
      sends24h: "Gönderim (24s)",
      failed24h: "Başarısız (24s)",
      sends7d: "Gönderim (7g)",
      held: "{{count}} tur beklemede",
      pendingApproval: "{{count}} kampanya onay bekliyor",
      reviewLink: "Onay kuyruğunu aç",
    },
    spend: {
      title: "SMS Harcama",
      segments: "Segment (bugün)",
      estCost: "Tahmini maliyet",
      breaker: "Devre Kesici",
      tripped: "Harcama kesici tetiklendi ({{reason}}) — kampanya gönderimi durdu.",
      reset: "Kesiciyi sıfırla",
      resetDone: "Kesici sıfırlandı",
    },
  },

  finance: {
    title: "Finansal Limitler",
    capsTitle: "Cap'ler (limitler)",
    capsHint: "Değerleri düzenle, sadece değişenler kaydedilir. Sunucu son sınırı doğrular.",
    save: "Kaydet",
    override: "Özel",
    default: "Varsayılan",
    resetField: "Varsayılana dön",
    resetToDefault: "Varsayılana dön",
    unitMb: "MB",
    unitUsd: "USD",
    rangeHint: "{{min}}–{{max}} aralığında olmalı",
    saveSuccess: "Finansal cap'ler güncellendi",
    resetSuccess: "Varsayılana döndürüldü",
    boundsError: "Değer izin verilen aralık dışında",
    switchEnabled: "Açıldı",
    switchDisabled: "Kapatıldı",
    caps: {
      verifyDailyCap: "Günlük Verify (OTP) limiti",
      smsSegmentDailyCap: "Günlük SMS segment limiti",
      smsPreviewDailyCap: "Günlük SMS önizleme limiti",
      smsRoundRecipientHardCap: "Tur başına alıcı limiti",
      smsManualSegmentMaxGuests: "Manuel segment maks. misafir",
      emailDailyCap: "Günlük e-posta limiti",
      smsTrPriceUsd: "SMS birim fiyatı (TR)",
      maxImageBytes: "Maks. fotoğraf boyutu",
      maxVideoDirectBytes: "Maks. video boyutu (direkt)",
      qrScanVisitorDailyCap: "Ziyaretçi başına günlük QR tarama",
      selfRegisterDailyCap: "Düğün başına günlük QR kayıt",
      smsApprovalThreshold: "SMS onay eşiği (alıcı)",
    },
    capsDesc: {
      selfRegisterDailyCap: "Bir düğünün QR/join linkinden 24 saatte kabul edeceği en fazla kayıt. Link herkese açık olduğu için sızma/bot durumunda misafir listesi ve OTP SMS bütçesi burada durur; aşılınca yeni kayıt reddedilir ve admin kanalına uyarı düşer. Organizatörün elle eklediği misafirler bu sayıya girmez.",
      smsApprovalThreshold: "Bir kampanyanın alıcı sayısı bu değeri AŞARSA kampanya oluşur ama yönetici onaylayana kadar tek SMS gitmez. 0 = her kampanya onay ister (kilitleme modu), 5000 = fiilen devre dışı. Eşik altı kampanyalar eskisi gibi otomatik gider.",
      qrScanVisitorDailyCap: "Aynı cihazın günde en fazla kaç QR tarama satırı yazabileceği. Kimlik düğün + IP + tarayıcı (user-agent) + gün karmasıdır — yalnız IP değil, bu yüzden salondaki ortak WiFi'de her cihaz kendi kotasına sahiptir. Aşan taramalar sessizce yazılmaz (misafir yine yönlendirilir).",
    },
    switchesTitle: "Kill Switch'ler",
    switchesHint: "Tümü varsayılan olarak AÇIK. Tehlikeli olanları kapatmak onay ister.",
    switches: {
      verifyEnabled: "SMS OTP Giriş",
      uploadsEnabled: "Medya Yükleme",
      imageTransformEnabled: "CDN Görsel Küçültme",
      smsApprovalEnabled: "SMS Onay Kapısı",
      organizerSeesGuestDeletedMedia: "Misafirin kaldırdıklarını organizatör görsün",
    },
    switchesDesc: {
      smsApprovalEnabled: "⚠️ Diğerlerinin AKSİNE: AÇIK = kapı devrede (eşik üstü kampanyalar onay bekler). Kapatmak onay şartını tamamen kaldırır — eşik üstü kampanyalar da doğrudan gider.",
      verifyEnabled: "Misafir/organizatör SMS giriş kodları; kampanyayı etkilemez.",
      uploadsEnabled: "Misafir foto/video yüklemesi; kapatmak tüm yüklemeleri durdurur.",
      imageTransformEnabled: "Anlık görsel yeniden boyutlandırma. Güvenli — yüklemeyi etkilemez.",
      organizerSeesGuestDeletedMedia: "Açık: misafirin kendi kaldırdığı medya organizatörün “Silinenler” listesinde salt okunur görünür (geri alınamaz). Kapalı (varsayılan): yalnız platform yöneticisi görür.",
    },
    monitoringTitle: "Canlı İzleme",
    mon: {
      verify: "Verify (bugün)",
      segments: "SMS segment (bugün)",
      breaker: "Harcama kesici",
      breakerOk: "Normal",
      breakerTripped: "Tetiklendi",
    },
    confirm: {
      title: "Tehlikeli işlem",
      verifyWarning: "Verify kapatılırsa misafir/organizatör SMS ile giriş yapamaz.",
      uploadsWarning: "Yüklemeler kapatılırsa misafirler fotoğraf yükleyemez.",
      detail: "Bu ayarı istediğin zaman tekrar açabilirsin.",
      turnOff: "Kapat",
      approvalWarning: "Onay kapısı kapatılırsa eşik üstü SMS kampanyaları onay beklemeden gönderilir.",
    },
  },

  maintenance: {
    title: "Hata Takibi",
    overview: "Genel Bakış",
    totalGroups: "Toplam Hata Grubu",
    unresolved: "Çözülmemiş",
    last24h: "Son 24 Saat",
    last7d: "Son 7 Gün",
    topRoutes: "En Çok Tekrar Eden Rotalar",
    errorGroups: "Hata Grupları",
    events: "Olaylar",
    markResolved: "Çözüldü İşaretle",
    markUnresolved: "Yeniden Aç",
    resolutionNote: "Çözüm notu",
    resolutionSaved: "Kaydedildi",
    firstSeen: "İlk Görülme",
    lastSeen: "Son Görülme",
    totalCount: "Toplam",
    requestId: "Request ID",
    purge: "Eski Kayıtları Temizle",
    purgeConfirm: "30 günden eski tüm kayıtlar silinecek. Devam?",
    purgeDetail: "error_log + error_groups tablosundan 30 günden eski kayıtlar silinir. Cron job her gece 03:00'te otomatik çalıştırır.",
    purged: "Eski kayıtlar temizlendi",
    stackTrace: "Stack Trace",
    noErrors: "Hata bulunamadı.",
    groupNotFound: "Hata grubu bulunamadı.",
    description: "Hata grupları ve sistem sağlığı izleme",
    statusResolved: "Çözüldü",
    statusOpen: "Açık",
    colLastSeen: "Son görülme",
    colKind: "Tür",
    colMethod: "Metot",
    colPath: "Rota",
    colError: "Hata",
    colCount: "Sayı",
    message: "Mesaj",
    dateLabel: "Tarih",
    weddingLabel: "Düğün",
    actorLabel: "Aktör",
    timeJustNow: "şimdi",
    timeMinutes: "{{count}}dk",
    timeHours: "{{count}}sa",
    timeDays: "{{count}}g",
    kind: {
      exception: "Exception",
      soft: "Soft Error",
    },
    filters: {
      all: "Tümü",
      unresolvedOnly: "Sadece açık",
      pathSearch: "Rota ara… (Enter)",
    },
  },
  // ─── Home Feed (Guest) ─────────────────────────────
  home: {
    rsvpNudge: "Düğüne katılacak mısın?",
    rsvpNudgeAction: "Yanıtla",
    rsvpNudgeTitle: "Sizi bekliyoruz!",
    rsvpNudgeText: "Planlama için lütfen katılım durumunuzu bildirin.",
    rsvpNudgeRespond: "Hemen Yanıtla",
    newActivity: "{{count}} yeni an paylaşıldı",
    topLiked: "En Çok Sevilen",
    recentActivity: "Son Aktiviteler",
    seeAll: "Tümünü gör",
    viewGallery: "Galeriyi Gör",
    welcomeBack: "Tekrar merhaba, {{name}}",
    rsvpStatus: "Katılım Durumunuz",
    rsvpNotResponded: "Henüz yanıtlamadınız",
    partyOf: "{{count}} kişilik katılım",
    weddingDetails: "Düğün Detayları",
    dateTime: "Tarih ve Saat",
    venue: "Mekan",
    updateRsvp: "Güncelle",
    respondNow: "Hemen Yanıtla",
    noMediaYet: "Henüz fotoğraf paylaşılmadı",
    noMediaYetHint: "İlk fotoğrafı yükleyen sen ol!",
    noActivityYet: "Henüz aktivite yok",
    empty: "Henüz etkinlik yok. İlk fotoğrafı sen yükle!",
    countdown: {
      daysLeft: "düğüne kaldı",
      daysAgo: "önce gerçekleşti",
      dayUnit: "Gün",
      hoursUnit: "Saat",
      minsUnit: "Dak",
      secsUnit: "Sn",
      label: "Geri Sayım Başladı",
      labelFor: "{{event}} — Geri Sayım",
      todayFor: "Bugün {{event}} günü!",
      today: "Bugün düğün günü!",
    },
  },

  themes: {
    title: "Temalar",
    description: "Platform genelinde kullanılan varsayılan arka planlar. Organizatörler düğün bazında özelleştirebilir.",
    backgrounds: "Arkaplanlar",
    slotGuestAuth: "Misafir Giriş",
    slotOrganizerAuth: "Organizatör Giriş",
    slotGuestCountdown: "Geri Sayım",
    slotGuestRsvp: "RSVP",
    slotGuestAuthDesc: "Misafir uygulama giriş ekranında görünen arka plan",
    slotOrganizerAuthDesc: "Organizatör paneli giriş ekranında görünen arka plan",
    slotGuestCountdownDesc: "Düğün başlamadan önceki geri sayım sayfasında görünen arka plan",
    slotGuestRsvpDesc: "Misafir davet yanıtlama sayfasında görünen arka plan",
    upload: "Yükle",
    change: "Değiştir",
    deleteSlot: "Sil",
    uploaded: "Yüklendi",
    deleted: "Silindi",
    uploadFailed: "Yükleme başarısız",
    deleteFailed: "Silme başarısız",
    noBackground: "Arka plan yok",
    dragDrop: "Görsel yüklemek için tıklayın veya sürükleyin",
    fileHint: "Maks. 10MB · JPEG, PNG, WebP, AVIF · Önerilen 1920×1080",
    active: "Aktif",
    confirmDelete: "Bu arka planı silmek istediğinizden emin misiniz?",
    // ─── Join Themes (Organizer) ──────────────────────
    presets: "Hazır Temalar",
    customize: "Özelleştir",
    palette: "Renk Paleti",
    fontPair: "Font Çifti",
    images: "Görseller",
    heroImage: "Hero Görsel",
    heroImageHint: "Davetiye sayfasının arka planı",
    gallery: "Galeri",
    galleryHint: "Maks 5 fotoğraf",
    preview: "Önizle",
    publish: "Yayınla",
    customized: "Özelleştirildi",
    reset: "Sıfırla",
    saveSuccess: "Tema kaydedildi",
    saveError: "Kayıt başarısız",
    uploadError: "Yükleme başarısız",
    deleteError: "Silme başarısız",
    fontPairHeadingPreview: "Düğün Başlığı",
    fontPairBodyPreview: "Misafir davet metninin önizlemesi",
    heroImageDesc: "Davetiye sayfasını ilk açtıklarında misafirlerin gördüğü tam ekran arka plan görseli. Yüklenmezse tema gradyanı kullanılır.",
    galleryDesc: "Davetiye sayfasının galeri bölümünde gösterilecek fotoğraflar. Boş bırakılırsa galeri bölümü görünmez.",
    joinTitle: "Davetiye Sayfası Teması",
    joinSubtitle: "Misafirlerin düğün davetniyenizi gördüğü sayfanın görünümünü özelleştirin.",
    previewCoupleName: "Ayşe & Mert",
    previewDateLocation: "12 Eylül 2026 · İstanbul",
    previewJoinTitle: "Aramıza Katıl",
    previewJoinSubtitle: "Daveti kabul etmek için adın ve telefon numaran yeterli.",
    previewRegisterBtn: "Kayıt Ol",
    uploadTooLarge: "Fotoğraf çok büyük. En fazla 10 MB yükleyebilirsin.",
    uploadInvalidType: "Sadece JPEG, PNG, WebP veya AVIF formatında fotoğraf yükleyebilirsin.",
    videoSection: "Scroll Animasyonu",
    videoDesc: "Misafir sayfayı aşağı kaydırdıkça video kare kare ilerler (Apple ürün sayfası efekti). MP4 veya WebM yükleyin.",
    videoUpload: "Video Yükle",
    videoExtracting: "Kareler çıkarılıyor...",
    videoUploading: "Yükleniyor...",
    videoProgress: "{{done}} / {{total}} kare",
    videoFrameCount: "{{count}} kare hazır",
    videoRemove: "Animasyonu Kaldır",
    videoSuccess: "Scroll animasyonu hazır",
    videoError: "Video işlenirken hata oluştu",
    videoInvalidType: "Sadece MP4 veya WebM formatında video yükleyebilirsin.",
    videoTooLarge: "Video çok büyük. En fazla 200 MB yükleyebilirsin.",
    deleteImageConfirm: "Bu görseli silmek istediğinizden emin misiniz?",
    deleteVideoConfirm: "Scroll animasyonunu silmek istediğinizden emin misiniz? Tüm kareler silinecek.",
    mobile: "Mobil",
    desktop: "Masaüstü",
    noHero: "Görsel yok",
    addImage: "Görsel ekle",
    changeImage: "Değiştir",
    // ─── Layout picker + per-layout editor ─────────────
    layoutPickerTitle: "Tema Düzeni",
    layoutPickerSubtitle: "Klasik düzen veya premium temalardan birini seçin. Düzenlenebilir temalar metin ve görsellerin tamamen özelleştirilmesine olanak tanır.",
    layoutEditorTitle: "Tema ayarları",
    layoutEditorSubtitle: "Metinleri, görselleri ve renkleri özelleştirin.",
    // ─── Layout picker grup/durum + tema adları ────────
    layoutGroupClassic: "Klasik",
    layoutGroupPremium: "Premium",
    layoutStatusEditable: "Düzenlenebilir",
    layoutStatusClassic: "Klasik tema",
    layoutStatusPreview: "Önizleme",
    layoutNames: {
      default: "Klasik (varsayılan)",
      cinematic: "Sinematik",
      minimal: "Minimal",
      parallax: "Romantik Parallax",
      editorial: "Bold Editorial",
      "dark-romance": "Dark Romance",
    },
  },

  // ─── Landing (pazarlama sitesi, `/`) ───────────────
  // ─── Baskı (ortak paket @wedding/print-kit) ─────────
  printKit: {
    title: "Baskı",
    description: "Düğününüze özel QR kartları — çift adları, tarih ve kendi QR kodunuzla. “Yazdır / PDF” ile gerçek ölçüde PDF alın ve matbaaya gönderin.",
    nameA: "1. isim",
    nameB: "2. isim",
    date: "Tarih",
    tables: "Masa numaraları",
    tablesHint: "Ör. 1-20, VIP — her masaya bir sayfa (en fazla {{max}}).",
    tableCard: "Masa kartı",
    tableCardSize: "A6 · 105 × 148 mm",
    welcomeSign: "Karşılama panosu",
    welcomeSignSize: "50 × 70 cm",
    handCard: "El kartı",
    handCardSize: "85 × 55 mm",
    pages: "{{count}} sayfa",
    print: "Yazdır / PDF",
    printing: "Yazdırma penceresi açıldı — hedef olarak “PDF olarak kaydet”i seçin.",
    printFailed: "Yazdırma penceresi açılamadı.",
    qrTarget: "QR şu adresi açar:",
    langNote: "kart metinleri düğün dilinde ({{lang}})",
    tip: "İpucu: Matbaaya göndermeden önce bir çıktıdaki QR’ı telefonunuzla okutun. Tarayıcıda “Arka plan grafikleri” açık olmalı.",
    tpl: {
      shareEyebrow: "Anılarınızı bizimle paylaşın",
      step1: "Okutun",
      step2: "Paylaşın",
      step3: "Ekranda izleyin",
      table: "Masa",
      welcome: "Hoş geldiniz",
      headlineA: "Bu gecenin her karesi",
      headlineB: "sizin elinizde.",
      captionStrong: "Kameranızla okutun,",
      caption: "fotoğraf ve videolarınızı paylaşın — kareniz birkaç saniye içinde salondaki ekranda.",
      noApp: "Uygulama indirmeniz gerekmez",
      handEyebrow: "Bu gecenin",
      handLine1: "bir karesi de",
      handLine2: "sizden.",
      handSteps: "Okut · Paylaş · İzle",
    },
  },

  // ─── Canlı demo girişi (web, F7) ─────────
  demoEnter: {
    title: "Canlı demoya hoş geldiniz",
    body: "Bir misafir gibi gezin: fotoğraf yükleyin, kalp bırakın, Sahne’yi açın. Telefon numarası gerekmez.",
    nameLabel: "Adınız (isteğe bağlı)",
    namePlaceholder: "Ör. Deniz",
    submit: "Demoya katıl",
    entering: "Giriliyor…",
    note: "Yüklediğiniz kareler moderasyona düşer, herkese açık olmaz ve her gece silinir.",
    failed: "Demoya şu an girilemedi, birazdan tekrar deneyin.",
    capReached: "Demo bugün çok yoğun — yarın tekrar deneyin.",
  },

  // ─── Albümü indir (ortak paket @wedding/album-export) ─────────
  albumExport: {
    button: "Albümü indir",
    meta: "{{count}} kare · {{size}}",
    empty: "Henüz onaylı kare yok.",
    onlyApproved: "Yalnız onaylı kareler, orijinal kalitede (ZIP)",
    partsHint: "Albüm büyük olduğu için {{parts}} parçaya bölündü; her parçayı ayrı indirin.",
    part: "Bölüm {{n}} ({{from}}–{{to}})",
    started: "İndirme başladı — büyük albümlerde birkaç dakika sürebilir.",
    failed: "Albüm bilgisi alınamadı.",
  },

  // ─── Admin: Satış & Site (landing içeriği) ─────────
  siteAdmin: {
    title: "Satış & Site",
    description: "Tanıtım sitesinde (wedding.mertbal.com) görünen fiyatları ve içerikleri yönetin. Kaydedilen değişiklik en geç 1–2 dakika içinde sitede görünür.",
    openSite: "Siteyi aç",
    reload: "Yenile",
    tabs: {
      pricing: "Fiyatlar",
      leads: "Teklifler",
      proof: "Sosyal kanıt",
      media: "Vitrin",
      retention: "Saklama",
      demo: "Misafir demosu",
      sales: "Online satış",
      legal: "Yasal",
      ledger: "Kayıt defteri",
    },
    save: "Kaydet",
    saving: "Kaydediliyor…",
    saved: "Kaydedildi — sitede 1–2 dakika içinde görünür.",
    saveFailed: "Kaydedilemedi: {{error}}",
    invalid: "Geçersiz alanlar var — işaretli satırları düzeltin.",
    loadFailed: "Ayarlar yüklenemedi.",
    retry: "Tekrar dene",
    unsaved: "Kaydedilmemiş değişiklik var",
    pricing: {
      showTitle: "Fiyatları sitede göster",
      showDesc: "Kapalıyken paket kartları fiyatsız görünür, online satış kapanır ve formda tahmin çıkmaz; ziyaretçi teklif ister.",
      packagesTitle: "Paket fiyatları",
      packagesHint: "Fiyat ve misafir/medya/depolama sayıları paket tanımından gelir — site kartı, satın alma, teklif formu ve manuel satış aynı sayıları kullanır. Misafir aralığına göre fiyat yok.",
      editPackages: "Paketlerde düzenle",
      packageGuests: "{{n}} misafire kadar",
      noteTitle: "Fiyat notu",
      noteHint: "Paket kartlarının altında görünür. Boşsa varsayılan metin 4 dilde gösterilir; buraya yazılan not çevrilmez.",
    },
    leads: {
      unavailableTitle: "Teklif kaydı henüz açık değil",
      unavailableBody: "Veritabanı güncellemesi (migration 052) uygulanınca formdan gelen talepler burada listelenir. O zamana kadar talepler yalnız e-postayla gelir.",
      funnelTitle: "Teklif formu — son 30 gün",
      funnelHint: "Kimliksiz günlük sayaçlar; sayfa yüklemesi başına her adım bir kez sayılır. Yüzdeler formu görenlere göre.",
      stepView: "Formu gördü",
      stepStep1: "Doldurmaya başladı",
      stepStep2: "İletişim adımına geçti",
      stepSubmit: "Gönderdi",
      pct: "%{{pct}}",
      filterAll: "Tümü",
      planChosen: "{{plan}} paketi",
      planCustom: "Daha kalabalık · özel teklif",
      statusLabel: "Durum",
      status: {
        new: "Yeni",
        contacted: "Arandı",
        won: "Kazanıldı",
        lost: "Kaybedildi",
      },
      empty: "Bu filtrede talep yok.",
      emailNotSent: "E-posta gitmedi",
      noEstimate: "Tahmin yok",
      note: "Not",
      notePh: "Görüşme notu (yalnız admin görür)",
      saveNote: "Notu kaydet",
      delete: "Sil",
      deleteConfirm: "{{name}} adlı kişinin talebi kalıcı olarak silinsin mi? (KVKK silme talebi için)",
      deleted: "Talep silindi.",
      updated: "Güncellendi.",
      failed: "İşlem başarısız: {{error}}",
      loadMore: "Daha fazla",
      loadFailed: "Talepler yüklenemedi.",
    },
    proof: {
      statsTitle: "Gerçek kullanım sayıları",
      statsDesc: "Sitede “X düğün albümü · Y kare paylaşıldı” olarak görünür. Sayılar veritabanından gelir; eşiğin altındaki sayı hiç gösterilmez.",
      show: "Sayıları sitede göster",
      minWeddings: "Gösterim eşiği — düğün",
      minMedia: "Gösterim eşiği — kare",
      current: "Şu an",
      currentWeddings: "{{n}} düğün (en az {{min}} onaylı karesi olan)",
      currentMedia: "{{n}} onaylı kare",
      visible: "sitede görünüyor",
      hidden: "eşik altında, gizli",
      off: "kapalı",
      unknown: "Sayılar şu an okunamadı.",
      testimonialsTitle: "Çift yorumları",
      testimonialsDesc: "Yalnız gerçek ve yayın izni alınmış yorumları ekleyin — uydurma yorum Ticari Reklam Yönetmeliği’ne aykırıdır. Metin girildiği dilde gösterilir.",
      empty: "Henüz yorum yok — sitede yorum alanı gizli.",
      add: "Yorum ekle",
      couple: "Çift",
      couplePh: "Ayşe & Can",
      when: "Ne zaman",
      whenPh: "Haziran 2026",
      city: "Şehir",
      cityPh: "İzmir",
      quote: "Yorum",
      quotePh: "Misafirlerimizin çektiği her kare ertesi sabah albümdeydi…",
      rating: "Puan",
      noRating: "Puansız",
      showOnSite: "Sitede göster",
      moveUp: "Yukarı taşı",
      moveDown: "Aşağı taşı",
      remove: "Kaldır",
      limit: "En fazla {{max}} yorum.",
    },
    media: {
      consent: "Yalnız çiftin yayın izni verdiği kareleri ve videoları yükleyin; misafir yüzleri görünen içerik için izin şart (KVKK).",
      photosTitle: "Gerçek düğün kareleri",
      photosHint: "Yüklendiğinde sitedeki stok görsellerin yerini alır; kareler sitedeki tüm fotoğraf alanlarında bu sırayla kullanılır. Yatay, en az 1600 px; JPEG/PNG/WebP/AVIF, en fazla 10 MB.",
      photosEmpty: "Henüz kare yok — sitede stok görseller gösteriliyor.",
      addPhotos: "Kare ekle",
      videoTitle: "Sahne videosu",
      videoHint: "Sahne bölümünün altında “Gerçek bir düğünden” başlığıyla oynatıcı olarak görünür. Yalnız MP4 (H.264), en fazla 95 MB; 30–60 sn önerilir. Kapak görseli sayfa açılışında video indirilmesini önler.",
      video: "Video",
      videoEmpty: "Video yok — bölüm gizli.",
      poster: "Kapak görseli",
      posterEmpty: "Kapak yok — tarayıcı videonun ilk karesini gösterir.",
      upload: "Yükle",
      replace: "Değiştir",
      uploadingN: "{{n}}/{{total}} yükleniyor",
      processing: "Yüklendi, sunucuda kaydediliyor…",
      uploaded: "{{count}} dosya yüklendi.",
      removeConfirm: "Bu dosya siteden ve depolamadan kalıcı olarak silinsin mi?",
      removed: "Kaldırıldı.",
      err: {
        too_large: "Dosya çok büyük (görsel 10 MB, video 95 MB).",
        mp4_only: "Video yalnız MP4 olabilir.",
        image_only: "Dosya geçerli bir JPEG/PNG/WebP/AVIF görseli değil.",
        limit: "En fazla 12 kare yüklenebilir.",
        network: "Bağlantı hatası — tekrar deneyin.",
        media_changed: "Vitrin başka bir sekmede değişmiş — liste yenilendi, tekrar deneyin.",
        length_required: "Dosya boyutu okunamadı — tekrar deneyin.",
      },
    },
    retention: {
      title: "Albüm saklama vaadi",
      desc: "Tanıtım sitesindeki SSS’de ve plan notunda görünür. Sistem onaylı kareleri otomatik silmez; bu sayı müşteriye verilen asgari süredir.",
      show: "Vaadi sitede göster",
      months: "Asgari süre (ay)",
      hidden: "Vaat gizli — SSS’de saklama sorusu görünmez.",
      warn: "Süreyi kısaltmak, daha önce bu vaatle satın alan müşterilere verilen sözü değiştirmez.",
    },
    demo: {
      title: "Misafir demosu (örnek düğün)",
      desc: "Ziyaretçiler /sample-wedding’e telefonsuz girip misafir uygulamasını (yükleme, galeri, Sahne) dener. Bu bir davetiye örneği değildir. Yüklemeleri moderasyona düşer, herkese açık olmaz ve her gece silinir.",
      state: "Durum",
      live: "Yayında",
      none: "Kurulmadı",
      seedMedia: "Tohum kare",
      visitors: "Bugünkü ziyaretçi",
      pending: "Onay bekleyen",
      setup: "Demoyu kur",
      reset: "Sıfırla",
      resetConfirm: "Demo düğünündeki her şey silinip yeniden kurulsun mu? (ziyaretçiler, yüklemeler, yorumlar)",
      setupDone: "Demo hazır — {{count}} tohum kare.",
      clearVisitors: "Ziyaretçileri temizle",
      clearConfirm: "Bugünkü demo ziyaretçileri ve yüklemeleri silinsin mi? Tohum kareler kalır.",
      cleared: "{{count}} ziyaretçi temizlendi.",
      open: "Misafir demosunu aç",
      moderation: "Moderasyona git",
      seedHint: "Tohum kareler Vitrin’deki gerçek karelerden kopyalanır; vitrin boşsa stok görseller kullanılır. Gece temizliği yalnız canlı ortamda çalışır.",
      slugTaken: "“{{slug}}” adresi gerçek bir düğüne ait — demo kurulamaz, hiçbir şey silinmedi.",
      ctaTitle: "Tanıtım sitesinde göster",
      ctaDesc: "Yayındayken “Nasıl çalışır” bölümünün “Paylaş” adımında küçük bir “Misafir gibi deneyin” bağlantısı görünür; ana düğmeler değişmez. Demo kurulmadan yayınlanamaz.",
      onSite: "Sitede yayında",
      offSite: "Sitede yayında değil",
      publish: "Sitede yayınla",
      unpublish: "Yayından kaldır",
      published: "Misafir demosu sitede yayınlandı.",
      unpublished: "Misafir demosu yayından kaldırıldı.",
    },
    sales: {
      selfServeTitle: "Organizatör kendi hesabını açabilsin",
      selfServeOn: "Açık: organizatör panelinde “Hesap oluştur” sayfası (/signup) görünür — ad + koşul onayı, e-posta kodu doğrulanınca ücretsiz (Free) hesap açılır. Giriş ekranı yine hesap açmaz.",
      selfServeOff: "Kapalı (önerilen): yalnız mevcut organizatörler giriş yapar; yeni hesapları siz açarsınız. Giriş ekranına bilinmeyen e-posta yazılırsa hesap açılmaz, adrese “teklif alın” bilgisi gider.",
      closeConfirm: "Yeni organizatör kaydı kapatılsın mı? Mevcut hesaplar etkilenmez.",
      ordersTitle: "Online satış (Satın al)",
      ordersLive: "Açık ve yayında: landing'de ücretli kartlarda “Satın al” görünüyor; siparişler aşağıya düşer.",
      ordersBlocked: "Açık ama yayında DEĞİL — aşağıdaki eksikler tamamlanınca görünür.",
      ordersOff: "Kapalı: ziyaretçiler yalnız teklif formunu görür.",
      ordersOpenConfirm: "Online satış açılsın mı? Landing'de “Satın al” görünecek; ödeme havale/EFT ile alınır ve siparişleri buradan onaylarsınız. Sözleşme metinlerini bir hukukçuya okutmanız önerilir.",
      ledgerRequired: "Online satış, kayıt defteri (migration 057) uygulanmadan açılamaz — sözleşme ve fiyat kanıtı tutulmalı.",
      needLegal: "Satıcı kimliği (ad/unvan, adres, e-posta) eksik:",
      needPricing: "Fiyatlar sitede gizli:",
      ordersHint: "Ödeme altyapısı (iyzico/PayTR) henüz yok: siparişe yanıt olarak ödeme bilgilerini gönderin, ödeme gelince “Ödendi” işaretleyin — hesap açılır ve alıcıya giriş + sözleşme e-postası gider.",
      selfServeMoved: "Organizatörün kendi hesabını açabilmesi bir platform ayarıdır; artık şurada:",
    },
    orders: {
      title: "Siparişler",
      desc: "Online satın almalar. Silinmez — fatura kaydı olarak 10 yıl saklanır.",
      filter: {
        pending: "Bekleyen",
        paid: "Ödendi",
        cancelled: "İptal",
        all: "Tümü",
      },
      unavailable: "Sipariş tablosu henüz yok — migration 053 uygulanınca siparişler burada görünür (o zamana kadar satın alma 503 döner).",
      empty: "Bu durumda sipariş yok.",
      more: "Daha fazla",
      loadFailed: "Siparişler yüklenemedi: {{error}}",
      buyer: "Alıcı",
      eventDate: "Etkinlik",
      address: "Fatura",
      email: "E-posta",
      phone: "Tel",
      created: "Sipariş: {{at}}",
      paidAt: "Ödeme: {{at}}",
      paymentNote: "Ödeme notu",
      paymentNotePh: "Ödeme notu (ör. havale 13.10, dekont no)",
      adminNote: "İç not",
      adminNotePh: "İç not (alıcı görmez)",
      markPaid: "Ödendi işaretle",
      cancel: "İptal et",
      saveNotes: "Notları kaydet",
      cancelConfirm: "{{number}} iptal edilsin mi?",
      paidCreated: "Ödendi — organizatör hesabı açıldı.",
      paidNoEmail: "Ödendi, ama alıcı e-postası gönderilemedi — “E-postayı gönder” ile tekrar deneyin.",
      deactivated: "Bu organizatör hesabı devre dışı — Kullanıcılar'dan yeniden etkinleştirin.",
      cancelled: "Sipariş iptal edildi.",
      cancelPaidConfirm: "{{number}} iptal edilsin mi (iade)? Paket düğünden düşer: düğünün başka paketi yoksa askıya alınır (yeni misafir ve yükleme durur). Misafir ve fotoğraflar silinmez.",
      paidExisting: "Ödendi — mevcut hesaba bağlandı (hesap planı değişmedi).",
      paidEmailSkipped: "Alıcıya e-posta gönderilmedi (seçiminiz) — sözleşme kopyasını başka yolla iletin.",
      emailInfoTitle: "Satın alma e-postaları",
      emailInfo1: "Sipariş anında alıcıya e-posta gitmez; işletme kutusuna bildirim gider — ödeme bilgisini o e-postayı yanıtlayarak gönderin.",
      emailInfo2: "“Ödendi” işaretlenince (isteğe bağlı) alıcıya giriş bağlantısı, paketin tanımlandığı düğün ve ön bilgilendirme formu + mesafeli satış sözleşmesinin kopyası gider. Sonradan “E-postayı gönder” ile de yollanabilir.",
      emailInfo3: "İptalde e-posta gitmez; iade yazışmasını siz yaparsınız.",
      paidTitle: "Ödendi olarak işaretle",
      applyTo: "Paketin tanımlanacağı düğün",
      applyNext: "Organizatör seçsin (paket hesabında bekler)",
      applyHint: "Paket tek etkinlik içindir; hesabın planı değişmez. Seçilen düğünün limitleri bu siparişin hakkına yükselir.",
      sendEmail: "Alıcıya giriş + sözleşme e-postası gönder",
      noEmailWarn: "Mesafeli satış sözleşmesinin kopyası alıcıya kalıcı biçimde iletilmek zorunda — göndermezseniz başka yolla iletin.",
      confirmPaid: "Onayla",
      close: "Vazgeç",
      weddingsFailed: "Düğünler yüklenemedi: {{error}}",
      entitlement: "Hak: {{guests}} misafir · {{media}} medya · {{storage}}",
      appliedTo: "Düğün: {{title}}",
      appliedNext: "Düğün: organizatörün seçmesi bekleniyor (paket hesabında)",
      move: "Taşı",
      apply: "Uygula",
      moved: "Paket düğüne tanımlandı.",
      emailSentAt: "E-posta gönderildi ({{at}})",
      emailNotSent: "E-posta gönderilmedi",
      sendEmailNow: "E-postayı gönder",
      resendEmail: "Yeniden gönder",
      emailSent: "Alıcıya e-posta gönderildi.",
      conflict: "Bu sipariş başka bir sekmede işlendi — liste yenilendi.",
      migrationRequired: "Migration 055 uygulanmadan “Ödendi” yapılamaz (hak sütunları yok).",
      weddingNotOwned: "Seçilen düğün bu alıcıya ait değil.",
      manualNew: "Manuel sipariş",
      manualHint: "Teklif/havale ile yapılan satış. Hesap planı DEĞİŞMEZ — sipariş tek düğüne hak olarak tanımlanır (“Ödendi” işaretleyince). Bekleyen siparişler 7 gün içinde ödenmezse otomatik iptal olur.",
      legacyBadge: "Geçiş (eski hesap planı)",
      manualPlan: "Paket",
      manualAmount: "Tutar (₺)",
      manualAmountEach: "Tutar — paket başına (₺)",
      manualQuantity: "Adet (paket)",
      manualQuantityHint: "{{count}} ayrı sipariş açılır — her biri tek düğün hakkı, kendi sipariş numarasıyla. Organizatör her paketi bir düğününe tanımlar.",
      pickOrganizer: "Mevcut organizatör (isteğe bağlı)",
      pickOrganizerPh: "E-posta ya da ad ile ara",
      pickNone: "Eşleşen organizatör yok — alıcı bilgilerini elle girin.",
      pickFailed: "Arama başarısız, tekrar deneyin.",
      pickedLabel: "Organizatör: {{name}} · {{email}}",
      pickChange: "Değiştir",
      pickWeddings: "{{count}} düğün",
      pickHint: "Seçilince ad, e-posta ve telefon hesaptan gelir; ödenince paket bu hesabın Paketlerim'ine düşer.",
      manualCreate: "Siparişi oluştur",
      manualCreated: "{{number}} oluşturuldu — ödeme gelince “Ödendi” işaretleyin.",
      manualCreatedMany: "{{count}} sipariş açıldı: {{numbers}} — ödeme gelince her birini “Ödendi” işaretleyin.",
      fix: "Düzelt",
      saveFix: "Düzeltmeyi kaydet",
      corrected: "Alıcı bilgisi düzeltildi.",
      foreignLabel: "Başka hesaptaki düğün (adres)",
      foreignPh: "ornek-dugun",
      foreignHint: "Düğün başka bir e-postayla açıldıysa adresini (slug) yazın; hak o düğüne tanımlanır, alıcının hesabı değişmez.",
      guestsShort: "{{n}} misafir",
      archived: "arşivde",
      overCap: "Bu düğünde zaten {{guests}} misafir var; sipariş hakkı {{cap}}. Fazlası silinmez ama QR ile yeni kayıt kapanır.",
      impact: "Etki — {{wedding}}: şu an {{guests}} misafir / {{media}} medya. İptal sonrası limit: {{guestsAfter}} misafir / {{mediaAfter}} medya.",
      impactOver: "⚠️ Düğün iptal sonrası limitin ÜSTÜNDE kalır: yeni misafir ve yükleme durur.",
      weddingNotFound: "Bu adreste düğün yok.",
      notPending: "Alıcı bilgisi yalnız bekleyen siparişte (ve durum değişikliğinden ayrı) düzeltilebilir.",
      contractCopy: "Sözleşme kopyası",
      noContract: "Bu siparişte saklı sözleşme metni yok (teklifle satış ya da defterden önceki sipariş).",
      ledgerEvents: "Defterde {{count}} kayıt.",
      listPrice: "(liste {{price}})",
      refundReasonPrompt: "İade gerekçesi (zorunlu, kayıt defterine yazılır):",
      moveReason: "Taşıma gerekçesi (zorunlu)",
      moveReasonPh: "ör. yanlış düğüne bağlanmıştı",
      paymentRef: "Ödeme referansı (zorunlu)",
      paymentRefHint: "Dekont no / havale açıklaması — tahsilatın kanıtı, kayıt defterine yazılır.",
      packageOption: "{{label}} · {{guests}} misafir · {{price}}",
      noPackages: "Satılabilir paket tanımı yok — önce Paketler’de tanımlayın.",
      noListPrice: "Bu paketin liste fiyatı yok (teklifle satılır) — gerekçe zorunlu.",
      listPriceNote: "Liste fiyatı {{price}} — tutar ve tüm sayılar paket tanımından.",
      discountNote: "Liste fiyatı {{price}} · indirim {{discount}} — gerekçe zorunlu.",
      reasonRequired: "Gerekçe (zorunlu — indirim / teklif)",
      errors: {
        paymentRef: "“Ödendi” için ödeme referansı (dekont / havale açıklaması) gerekli.",
        reason: "Gerekçe gerekli (en az 3 karakter).",
        packageInUse: "Bu paket kullanılmış (misafir/medya var ya da etkinlik geçti) — boşa çıkarılamaz; iade ya da başka düğüne taşıma yapın.",
        targetHasPackage: "Seçilen düğünde zaten ödenmiş bir paket var — bir düğüne tek paket.",
        packageNotFound: "Paket tanımı bulunamadı ya da pasif.",
        packageNotSellable: "Varsayılan (Free) paket satılmaz.",
        invalidTransition: "Bu sipariş durumunda bu işlem yapılamaz.",
      },
    },
    ledger: {
      title: "Satış kayıt defteri",
      desc: "Fiyat ve koşul ayarlarının, paket limitlerinin, siparişlerin ve ek paketlerin kaydı. Yalnız eklenir, değiştirilemez ve silinemez; en az 10 yıl saklanır. Hangi tarihte hangi fiyatın geçerli olduğunu ve alıcının onayladığı sözleşme metnini buradan gösterebilirsiniz.",
      verify: "Bütünlüğü doğrula",
      verifyOk: "Defter sağlam — {{count}} kayıt baştan sona doğrulandı.",
      verifyBroken: "Dikkat: #{{seq}} numaralı kayıt değiştirilmiş ya da zincir kopmuş. Yedekle karşılaştırın.",
      unavailable: "Kayıt defteri henüz yok — migration 057 uygulanınca kayıt tutulmaya başlar (online satış ondan önce açılamaz).",
      empty: "Bu filtrede kayıt yok.",
      loadFailed: "Kayıt defteri okunamadı: {{error}}",
      more: "Daha fazla",
      actor: "Kim",
      contract: "Alıcının onayladığı metin (özet SHA-256: {{hash}})",
      filter: {
        all: "Tümü",
        settings: "Fiyat ve koşullar",
        plan: "Paket limitleri",
        order: "Siparişler",
        addon: "Ek paketler",
      },
      accountPlanSubject: "Hesap {{id}}: {{before}} → {{after}}",
      packageSubject: "{{kind}} {{label}} · {{id}}",
      packageFree: "Free paketi",
      packageLegacy: "Geçiş paketi",
      events: {
        created: "oluşturuldu",
        paid: "ödendi",
        cancelled: "iptal",
        moved: "taşındı",
        corrected: "düzeltildi",
        applied: "düğüne tanımlandı",
        updated: "değişti",
        deleted: "kaldırıldı",
        baseline: "defter öncesi değer",
        accountPlan: "Hesap planı atandı",
        granted: "paket verildi",
        assigned: "düğüne tanımlandı",
        replaced: "yerini ücretli paket aldı",
        revoked: "geri alındı",
        noted: "not değişti",
        propagated: "tanım satılmışlara uygulandı",
      },
    },
    addons: {
      save: "Paketleri kaydet",
      title: "Ekstra kişi paketleri (QR ile ekstra kayıt)",
      desc: "Düğünün misafir kotası dolunca organizatör QR ile kaydolacak ekstra kişiler için paket açar. Paket açılınca HEMEN aktif olur ve “ödeme bekliyor” düşer; tahsilat Online satış → Ek paketler'den. Fiyat her zaman buradan (sunucu) okunur.",
      enabled: "Organizatör yeni paket açabilsin",
      seats: "Kişi",
      price: "Fiyat (₺)",
      seatsFor: "{{n}}. paket kişi sayısı",
      priceFor: "{{n}}. paket fiyatı",
      perGuest: "kişi başı ≈ {{price}}",
      invalid: "Kişi 1–1000, fiyat 0–100.000 tam sayı olmalı; aynı kişi sayısı iki kez olamaz.",
      panelTitle: "Ek paketler",
      panelDesc: "Organizatörlerin açtığı QR ekstra kayıt paketleri. Açılınca aktif; havale görülünce “Ödendi”, ödenmezse “İptal” (ekstra koltuklar hemen kapanır).",
      filter: { pending: "Ödeme bekliyor", paid: "Ödendi", cancelled: "İptal", all: "Tümü" },
      markPaid: "Ödendi",
      cancel: "İptal et",
      paidConfirm: "/{{slug}} için +{{seats}} kişilik paket ödendi olarak işaretlensin mi?",
      paidRefPrompt: "/{{slug}} için +{{seats}} kişilik paket ({{amount}}) ödendi olarak işaretlensin mi? Ödeme referansı (dekont no / havale açıklaması, zorunlu):",
      paymentRefRequired: "Ödeme referansı (dekont / havale açıklaması) gerekli.",
      cancelConfirm: "/{{slug}} için +{{seats}} kişilik paket iptal edilsin mi? Ekstra koltuklar hemen kapanır; kaydolmuş misafirler silinmez.",
      markedPaid: "Paket ödendi olarak işaretlendi.",
      cancelled: "Paket iptal edildi.",
      empty: "Bu durumda paket yok.",
      unavailable: "Ek paket tablosu henüz yok — migration 056 uygulanınca burada görünür.",
      loadFailed: "Ek paketler yüklenemedi: {{error}}",
    },
    legal: {
      title: "Yasal kimlik",
      desc: "KVKK aydınlatma metnindeki veri sorumlusu ve Kullanım koşullarındaki hizmet sağlayıcı bu bilgilerden beslenir. Ücretli satış (sipariş) açılabilmesi için ad/unvan, adres ve e-posta zorunludur.",
      publicWarn: "Girilen her alan /privacy ve /terms sayfalarında HERKESE AÇIK yayımlanır. Yayımlanmasını istemediğiniz alanı boş bırakın — boş alan sayfada hiç görünmez.",
      complete: "Kimlik tamam — sözleşme ve satış sayfaları açılabilir.",
      incomplete: "Eksik: ad/unvan, adres ve e-posta girilene kadar sayfalarda yalnız iletişim e-postası görünür ve ücretli satış kapalı kalır.",
      name: "Ad soyad / ticaret unvanı",
      titleField: "Unvan / meslek (isteğe bağlı)",
      address: "Adres",
      phone: "Telefon",
      email: "E-posta (boşsa contact@mertbal.com)",
      taxOffice: "Vergi dairesi",
      taxId: "Vergi / TC kimlik no",
      mersis: "MERSİS no",
      kep: "KEP adresi",
      openKvkk: "KVKK sayfasını aç",
      openTerms: "Koşullar sayfasını aç",
      clearConfirm: "Tüm yasal kimlik alanları boşaltılıp kaydedilsin mi? Sayfalarda yalnız iletişim e-postası kalır.",
      clear: "Tümünü boşalt",
    },
  },

  plansAdmin: {
    siteNote: "Paket tanımı TEK KAYNAKTIR: sitedeki kart, online satın alma, manuel satış ve “Paket ver” misafir/medya/depolama/SMS sayılarını ve FİYATI buradan alır. Tanıtım sitesi yalnız Free · Pro · Max’i gösterir; adlar sabittir. Diğer paketler özeldir (kurumsal): sitede görünmez, teklifle / “Paket ver” ile satılır. Satılmış paket bir sözleşmedir: tanımı değiştirmek yalnız YENİ satışları etkiler, satılmış paketler satın alındığı sayılarla kalır.",
    onSite: "Sitede",
    onSiteHint: "Tanıtım sitesinde gösterilir — silinemez, limitleri düzenlenebilir",
    private: "Özel",
    privateHint: "Özel plan — tanıtım sitesinde görünmez",
    reactivate: "Yeniden etkinleştir",
    created: "Plan oluşturuldu.",
    updated: "Plan güncellendi.",
    deleted: "Plan pasife alındı.",
    reactivated: "Plan yeniden etkinleştirildi.",
    failed: "İşlem başarısız: {{error}}",
    sitePlanLocked: "Bu paket tanıtım sitesinde — silinemez.",
    subtitle: "Paket tanımları: sayılar ve fiyat",
    price: "Fiyat (₺)",
    priceHint: "Boş bırakılırsa online satılmaz — teklifle (özel/kurumsal paket).",
    priceQuote: "Teklif ile",
    priceDefault: "Varsayılan paket (Free) her zaman ₺0.",
    sold: "satılmış paket",
    accountUsers: "{{n}} hesabın eski hesap planı",
    soldNote: "Bu paket {{n}} kez satıldı. Değişiklik yalnız YENİ satışlara uygulanır; satılmış paketler satın alındığı sayılarla kalır (sözleşme). Bir müşteriye daha fazlası gerekiyorsa yükseltme ayrı bir satıştır.",
    updatedNewSalesOnly: "Plan güncellendi · yeni satışlara uygulanır; satılmış {{n}} paket satın alındığı sayılarla kaldı.",
    errors: {
      defaultLocked: "Varsayılan (Free) paket paket modelinde değiştirilemez.",
      defaultPrice: "Varsayılan paket ücretsizdir (₺0).",
      priceZero: "Ücretli paketin fiyatı 0 olamaz — boş bırakın (teklifle) ya da fiyat girin.",
      migrationRequired: "Fiyat için migration 059 uygulanmalı.",
      invalid: "Geçersiz değer.",
    },
  },
  // ─── Admin: kullanıcı paketleri + Paket ver (2026-10-16) ─────────
  adminPackages: {
    title: "Paketler",
    modeNote: "Paket modeli: hesap planı limit belirlemez, her düğünün limiti paketinden. Kurumsal müşteriye özel sınırlı paket verin.",
    grant: "Paket ver",
    guests: "{{n}} misafir",
    grantTitle: "Paket ver",
    grantHint: "1 sipariş = 1 paket: ödenmiş manuel sipariş açılır. Paketin TÜM sayıları paket tanımından (Paketler). Tutar 0 ya da indirimli olabilir; tutar > 0 ise ödeme referansı zorunlu. Gerekçe iç nota ve kayıt defterine yazılır. Düğün seçerseniz pakete tanımlanır (Free / geçiş paketi biter); seçmezseniz kullanıcı Paketlerim'den kullanır.",
    plan: "Paket",
    amount: "Tutar (₺)",
    paymentNote: "Ödeme referansı (zorunlu)",
    duplicateConfirm: "Bu kullanıcıya son 10 dakikada aynı paket zaten verildi. İkinci bir paket daha verilsin mi? (İki sekme / yeniden denemeyse İptal’e basın.)",
    duplicateSkipped: "İkinci paket verilmedi — son 10 dakikadaki paket geçerli.",
    revoke: "Geri al",
    revokePrompt: "“{{label}}” paketi geri alınsın mı ({{wedding}})? Düğünün başka paketi yoksa askıya alınır (yeni misafir/yükleme durur, veri silinmez). Gerekçe (zorunlu):",
    revoked: "{{label}} paketi geri alındı.",
    wedding: "Düğün",
    weddingNone: "Tanımlama — kullanılabilir kalsın",
    weddingOption: "{{title}} — şu an: {{pkg}}",
    reason: "Gerekçe",
    reasonPh: "ör. telefonla satış, telafi, kurumsal anlaşma",
    submit: "Paketi ver",
    granted: "Paket verildi: {{number}}",
    grantedTo: "Paket verildi: {{number}} → {{title}}",
    packagesMode: "Hesap paket modelinde — hesap planı değiştirilemez, “Paket ver” kullanın.",
    errors: {
      packagesUnavailable: "Migration 058 uygulanmadan paket verilemez.",
      weddingNotFound: "Düğün bu kullanıcıya ait değil.",
      ordersUnavailable: "Sipariş tablosu yok (migration 053/055).",
      generic: "Paket verilemedi: {{error}}",
      paymentRef: "Tutar 0’dan büyükse ödeme referansı (dekont / havale açıklaması) zorunlu.",
      targetHasPackage: "Bu düğünde zaten ödenmiş bir paket var — bir düğüne tek paket.",
      packageNotFound: "Paket tanımı bulunamadı ya da pasif.",
      packageNotSellable: "Varsayılan (Free) paket verilemez — hesapta zaten var.",
      reason: "Gerekçe gerekli (en az 3 karakter).",
      notActive: "Paket zaten bitmiş ya da geri alınmış.",
      notFound: "Paket bu kullanıcıya ait değil.",
    },
  },

  // ─── Paketlerim (paket modeli, 2026-10-16) ─────────
  packages: {
    title: "Paketlerim",
    subtitle: "Her düğün bir pakete bağlıdır. Hesabınızın bir Free paketi vardır; her ödenmiş sipariş yeni bir pakettir.",
    buy: "Paket al",
    loadFailed: "Paketler yüklenemedi.",
    tileAvailable: "Kullanılabilir",
    tileInUse: "Kullanımda",
    tilePending: "Ödeme bekleyen",
    tabPackages: "Paketler",
    tabOrders: "Siparişler",
    available: "Kullanılabilir",
    inUse: "Kullanımda",
    pending: "Ödeme bekleyen",
    endedTitle: "Biten",
    noneAvailable: "Kullanılabilir paketiniz yok. Yeni düğün için paket alın.",
    limits: "{{guests}} misafir · {{media}} fotoğraf/video · {{storage}}",
    freeName: "Free",
    legacyName: "{{plan}} (geçiş)",
    freeHint: "Hesap başına bir kez. Düğün ücretli pakete yükseltilince tükenir.",
    paidHint: "Bir düğüne tanımlandığında hizmet başlar.",
    pendingHint: "Sipariş: {{date}}. Havale/EFT talimatı e-postanızda — açıklamaya sipariş numarasını yazın. Ödeme onaylanınca paket kullanılabilir olur.",
    ended: {
      replaced: "Yerini ücretli paket aldı",
      revoked: "Geri alındı",
      cancelled: "İptal / iade edildi",
    },
    openWedding: "Bu paketle düğün aç",
    orderUnassigned: "Henüz bir düğüne tanımlanmadı",
    orderPendingShort: "Ödeme bekleniyor",
    addonsTitle: "QR ekstra kişi paketleri",
    addonSeats: "+{{seats}} kişi",
  },

  // ─── Misafir kotası + QR ekstra kayıt (ortak kart, 2026-10-15) ─────────
  guestCapacity: {
    title: "Misafir kotası",
    breakdown: "Paket limiti {{limit}} · ekstra {{extra}} (yalnız QR)",
    full: "Kota doldu — QR ile yeni kayıt kabul edilmiyor. Misafire “düğün sahibine haber verin” mesajı gösteriliyor. Ekstra paket açarak genişletebilirsiniz.",
    almost: "Kota dolmak üzere. Dolunca QR ile yeni kayıt kabul edilmez.",
    qrExtra: "QR ile ekstra kayıt",
    off: "Kapalı",
    on: "Açık · +{{seats}}",
    packButton: "+{{seats}} kişi · {{price}}",
    statusPending: "ödeme bekliyor",
    statusPaid: "ödendi",
    due: "Ödenecek: {{amount}} (havale/EFT — bilgiler e-postayla gelir)",
    withdraw: "Geri çek",
    cancel: "İptal et",
    withdrawConfirm: "+{{seats}} kişilik paket geri çekilsin mi? Ekstra koltuklar kapanır, ücret alınmaz.",
    cancelConfirmAdmin: "+{{seats}} kişilik paket iptal edilsin mi? Ekstra koltuklar hemen kapanır (ödenmişse iade sizde).",
    withdrawn: "+{{seats}} kişilik paket kapatıldı.",
    opened: "+{{seats}} ekstra kişi açıldı.",
    confirmTitle: "+{{seats}} ekstra kişi",
    confirmLimit: "QR ile kayıt sınırı {{from}} → {{to}} olur.",
    confirmQrOnly: "Ekstra kişiler yalnız QR ile kaydolanlar içindir; misafir listesine elle ekleme paket limitine bağlı kalır.",
    confirmBilling: "Paket HEMEN açılır; {{price}} tutarında “ödeme bekliyor” siparişi oluşur, havale/EFT ile ödenir.",
    confirmUnpaid: "{{days}} gün içinde ödenmezse paket otomatik iptal edilir ve ekstra kayıtlar durur (kaydolmuş misafirler silinmez). Aynı anda tek ödenmemiş paket açılabilir.",
    confirmWithdraw: "Paket açıldıktan sonra QR ile kimse kaydolmadıysa ücretsiz geri çekebilirsiniz.",
    comp: "İkram (ücretsiz)",
    pendingExists: "Ödenmemiş bir ek paket var — ödenmeden (ya da geri çekilmeden) yenisi açılamaz.",
    compReason: "İkram gerekçesi (zorunlu)",
    compReasonPh: "ör. telafi, kurumsal anlaşma",
    accept: "Fiyatı ve koşulları okudum, onaylıyorum.",
    confirmButton: "+{{seats}} kişiyi aç",
    close: "Vazgeç",
    loadFailed: "Misafir kotası yüklenemedi.",
    retry: "Tekrar dene",
    migrationHint: "Ekstra paketler için migration 056 uygulanmalı (kota kuralı yine çalışıyor).",
    errors: {
      unavailable: "Ekstra paketler şu an açılamıyor.",
      disabled: "Ekstra kişi paketleri şu an kapalı.",
      unknownPack: "Bu paket artık sunulmuyor — sayfayı yenileyin.",
      duplicate: "Bu paket az önce açıldı — sayfayı yenileyin.",
      inUse: "Bu paketin koltukları kullanıldı; geri çekilemez.",
      paid: "Ödenmiş paket geri çekilemez — destekle iletişime geçin.",
      generic: "İşlem başarısız: {{error}}",
      pendingExists: "Ödenmemiş bir ek paket var — önce onu ödeyin ya da geri çekin.",
      suspended: "Düğünün paketi yok (askıda) — ek kişi paketi açılamaz.",
      reason: "İkram için gerekçe gerekli.",
    },
    pkg: {
      title: "Paket",
      order: "sipariş {{number}}",
      account: "hesap geneli plan",
      trial: "ücretsiz deneme — paket yok",
      media: "Fotoğraf/video",
      storage: "Depolama",
      sms: "SMS",
      free: "Free paket",
      legacy: "geçiş paketi (eski hesap planı)",
      suspended: "paket yok — düğün askıda",
    },
  },

  planChange: {
    accountPlanWarning: "Hesap planı, paket tanımlanmamış TÜM düğünlere süresiz uygulanır (hesap geneli). Pro ve Max düğün başına satılır: burada atanamaz — Satış & Site → Online satış → “Manuel sipariş” açın (Adet ile birden çok paket). Hesap planı yalnız Free'ye dönüş ve özel (kurumsal/abonelik) anlaşmalar içindir. Eski Pro/Max hesap için aşağıdaki “Hesap planı → düğün paketleri” aracını kullanın.",
    title: "Hesap planını değiştir",
    rowLabel: "Hesap planı",
    perWeddingOption: "Düğün başına satılır — “Manuel sipariş” ile",
    perWeddingPlan: "Pro/Max hesap planı olarak atanamaz — düğün başına satılır. Satış & Site → Online satış → “Manuel sipariş” kullanın.",
    conversion: {
      title: "Hesap planı → düğün paketleri",
      desc: "Bu hesaba, “paket = tek düğün” modelinden önce {{plan}} hesap planı atanmış: paketsiz tüm düğünler {{plan}} limitleriyle çalışıyor ve sipariş numarası yok. Dönüştürünce seçtiğiniz her düğüne 0 ₺ geçiş siparişi açılır (G ile başlayan numara, kayıt defterinde); düğün hiçbir limit kaybetmez. Hesap {{to}} (ücretsiz deneme) planına iner.",
      notConvertible: "Bu hesabın planı ({{plan}}) özel bir plan: bilerek hesap geneli kalır (kurumsal). Dönüştürülmez.",
      guests: "{{count}} misafir",
      hasOrder: "Paketi var: {{number}}",
      notOwner: "Sahibi başka hesap",
      archived: "arşivde",
      unselectedWarn: "Seçilmeyen {{count}} düğün ücretsiz deneme limitlerine düşer ({{guests}} misafir) — veri silinmez, limit üstünde yeni kayıt ve yükleme durur. Test düğünlerini seçmeyin.",
      button: "Düğün paketlerine dönüştür",
      confirm: "{{count}} düğüne {{plan}} geçiş paketi açılacak ve hesap {{to}} planına inecek. Geri alınamaz (gerekirse siparişler tek tek iptal edilir). Devam edilsin mi?",
      done: "Dönüştürüldü — {{count}} geçiş siparişi: {{numbers}}",
      doneNone: "Dönüştürüldü — hesap {{to}} planına indi, paket açılmadı",
      failed: "Dönüştürülemedi: {{error}}",
      planChanged: "Hesabın planı arada değişmiş — sayfayı yenileyip tekrar deneyin",
      loadFailed: "Dönüştürme bilgisi yüklenemedi: {{error}}",
    },
  },

  privacyAdmin: {
    title: "KVKK Başvuruları",
    description: "Bir kişi verisinin silinmesini istediğinde: telefon numarasıyla tüm düğünlerdeki misafir kayıtlarını bulun, önizleyin ve tek seferde silin/anonimleştirin. Arama ve silme denetim kaydına (numara maskeli) yazılır.",
    phoneLabel: "Telefon numarası",
    phoneHint: "0555 123 45 67 ya da +44… biçiminde yazın.",
    willSearch: "Aranacak: {{phone}}",
    invalidPhone: "Geçerli bir telefon numarası girin.",
    search: "Bul",
    lookupFailed: "Arama yapılamadı: {{error}}",
    resultTitle: "{{phone}} için bulunanlar",
    resultMeta: "Doğrulama kodu: {{authCodes}} · Teklif talebi: {{leads}} · Denetim kaydı: {{audit}}",
    ordersKept: "Bu numaraya ait {{count}} sipariş var — fatura kaydı olarak vergi mevzuatı gereği 10 yıl saklanır, bu araçla silinmez.",
    organizerNote: "Bu numarayla kayıtlı bir organizatör hesabı da var. Organizatör hesabı bu araçla silinmez; gerekiyorsa ayrıca kapatın:",
    nothing: "Bu numaraya ait kayıt bulunamadı.",
    noGuests: "Misafir kaydı yok; yalnız kod/teklif/denetim kayıtları temizlenecek.",
    noName: "(adsız)",
    guestActive: "Aktif misafir",
    guestRemoved: "Düğünden çıkarılmış",
    counts: "{{media}} medya · {{comments}} yorum · {{likes}} beğeni · {{rsvp}} LCV · {{sms}} SMS",
    eraseExplain: "Silinir: misafirin fotoğraf/videoları (dosyalarıyla), yorum ve beğenileri, LCV'si, doğrulama kodları, teklif talepleri ve açık oturumları. Misafir kaydı anonimleşir (ad ve telefon kaldırılır); SMS gönderim kayıtlarında ve denetim kaydında numara maskelenir. Geri alınamaz.",
    erase: "Sil ve anonimleştir",
    eraseConfirm: "{{phone}} numarasına ait {{count}} misafir kaydı ve tüm ilişkili veriler kalıcı olarak silinecek. Geri alınamaz. Devam edilsin mi?",
    erased: "Silme tamamlandı",
    eraseFailed: "Silinemedi: {{error}}",
    erasedSummary: "{{phone}}: {{guests}} misafir kaydı anonimleşti, {{media}} medya silindi, {{audit}} denetim kaydında numara maskelendi.",
  },

  landing: {
    meta: {
      title: "{{brand}} — Kaçırdığınız her an, tek albümde",
      description: "Misafirleriniz QR kodu okutur; çektikleri her fotoğraf ve video orijinal kalitesiyle tek albümde toplanır, onayladıklarınız salondaki dev ekranda döner. Uygulama indirmek yok.",
    },
    nav: {
      home: "{{brand}} ana sayfa",
      how: "Nasıl çalışır",
      sahne: "Sahne",
      themes: "Davetiyeler",
      plans: "Planlar",
      faq: "SSS",
      contact: "Teklif",
      login: "Giriş yap",
      cta: "Fiyat al",
      menu: "Menüyü aç",
      close: "Menüyü kapat",
      skip: "İçeriğe geç",
    },
    hero: {
      eyebrow: "QR kodlu düğün albümü",
      titleA: "Kaçırdığınız her an,",
      titleB: "tek albümde.",
      lead: "Misafirleriniz QR kodu okutur, çektikleri fotoğraf ve videolar orijinal kalitesiyle albümünüze düşer. Onayladıklarınız gece boyunca salondaki dev ekranda döner.",
      ctaPrimary: "Fiyat al",
      ctaHow: "Nasıl çalıştığını görün",
      live: "Canlı",
      live1: "Masa 7’den yeni bir kare",
      live2: "Elif bir video paylaştı",
      live3: "Gelinin dansına 14 kalp",
      promise1: "Uygulama yok — QR’ı okutmak yeterli",
      promise2: "Orijinal kalite, sıkıştırma yok",
      promise3: "Onayladığınız kare saniyeler içinde dev ekranda",
    },
    marquee: {
      m1: "Nikâh",
      m2: "Kına gecesi",
      m3: "Düğün",
      m4: "Nişan",
      m5: "After party",
      m6: "Söz",
    },
    manifesto: {
      eyebrow: "Tanıdık geldi mi?",
      body: "Düğünden sonraki sabah, gecenin en güzel kareleri kırk yedi telefona, on iki WhatsApp grubuna ve hiç gelmeyecek bir “sonra atarım”a dağılmış olur.",
      resolve: "Biz onları tek bir albümde, ilk günkü kalitesiyle bir araya getiriyoruz.",
      chip1: "“Fotoğrafları atar mısın?”",
      chip2: "WhatsApp · sıkıştırıldı",
      chip3: "Bağlantının süresi doldu",
      chip4: "“Sonra atarım” — Kuzen Emre",
      chip5: "Depolama alanı dolu",
      chip6: "Drive klasörüne erişim yok",
    },
    how: {
      eyebrow: "Nasıl çalışır",
      title: "Üç adım.",
      titleAccent: "Sıfır uygulama.",
      lead: "Misafirleriniz için telefon kamerası kadar tanıdık. Sizin için tek bir albüm.",
      step1Title: "Okut",
      step1Body: "Masadaki karttaki, davetiyedeki ya da karşılama panosundaki QR kodu telefon kamerasıyla okuturlar. İndirme yok, şifre yok.",
      step2Title: "Paylaş",
      step2Body: "Telefon numarasına gelen tek seferlik kodla girer, fotoğraf ve videolarını yüklerler. Sıkıştırma yok — ne çektilerse o.",
      step3Title: "İzle",
      step3Body: "Onayladığınız her kare salondaki dev ekrana (Sahne) düşer — misafirlerin telefonlarından gelen kalplerle.",
      cardShare: "Anılarınızı bizimle paylaşın",
      cardTable: "Masa 7",
      cardScan: "Kameranızla okutun",
      phoneTitle: "Anı paylaş",
      phoneVerified: "Numaranız doğrulandı",
      phoneUploading: "4 dosya yükleniyor",
      phoneOriginal: "Orijinal kalite",
      phoneSend: "Paylaş",
      tryAsGuest: "Misafir gibi deneyin",
      tryAsGuestNote: "Örnek düğün — telefon numarası gerekmez, paylaşılanlar her gece silinir.",
    },
    sahne: {
      eyebrow: "Sahne",
      title: "Gecenin kareleri,",
      titleAccent: "anında",
      titleEnd: "dev ekranda.",
      lead: "Misafir çeker, siz onaylarsınız, kare saniyeler içinde dev ekranda. Telefonlardan gönderilen kalpler ekranda süzülür, yorumlar balona dönüşür.",
      live: "Canlı",
      watching: "{{count}} izliyor",
      sharedBy: "{{name}} paylaştı",
      comment1: "Bu dans efsane 💃",
      comment2: "Gelinin gülüşüne bakın ❤️",
      comment3: "Halaya ben de geliyorum!",
      join: "Kutlamaya katıl",
      joinHint: "Fotoğraf paylaş & kalp gönder",
      f1Title: "Saniyeler içinde ekranda",
      f1Body: "Onay verdiğiniz an kare salondaki bütün ekranlara aynı anda düşer.",
      f2Title: "Telefondan kalp ve yorum",
      f2Body: "Misafirler tek dokunuşla tepki verir; ekranın köşesinde kimlerin izlediği görünür.",
      f3Title: "Ekran sizin kontrolünüzde",
      f3Body: "Telefonunuzdan sıradaki kareyi seçin, öne alın, duraklatın ya da gizleyin.",
      rejiLabel: "Reji",
      rejiNext: "Sıradaki",
      rejiSpotlight: "Öne al",
      videoCaption: "Gerçek bir düğünden: Sahne ekranı gece boyunca",
    },
    control: {
      eyebrow: "Kontrol",
      title: "Gecenin editörü",
      titleAccent: "sizsiniz.",
      lead: "Albüme neyin gireceğine, ekranda neyin döneceğine siz karar verirsiniz. Gerisini panel halleder.",
      modTitle: "Yayından önce onay",
      modBody: "Her kare önce moderasyon kuyruğuna düşer. Onaylayın, reddedin; gerekirse paylaşanı tek dokunuşla engelleyin.",
      modPending: "{{count}} kare onay bekliyor",
      modApprove: "Onayla",
      modReject: "Reddet",
      otpTitle: "Yalnızca gerçek misafirler",
      otpBody: "Giriş, telefona gelen tek seferlik kodla. Albümünüz herkese açık bir bağlantı değil.",
      otpLabel: "Doğrulama kodu",
      rsvpTitle: "LCV yanıtları, anında",
      rsvpBody: "Kim geliyor, kim gelmiyor, kim hâlâ düşünüyor — panelde canlı.",
      rsvpYes: "Geliyor",
      rsvpNo: "Gelmiyor",
      rsvpPending: "Yanıt yok",
      smsTitle: "SMS ile davet ve hatırlatma",
      smsBody: "Herkese davet, yanıt vermeyenlere nazik bir hatırlatma. Kitleyi seçin, zamanlayın.",
      smsPreview: "Sayın Ayşe Yılmaz, 23 Ağustos’ta Deniz & Arda’nın düğününde sizi aramızda görmekten mutluluk duyarız. Katılım durumunuzu bildirmek için bağlantıya dokunun.",
      smsSegment: "LCV vermeyenler",
      qrTitle: "QR analitiği",
      qrBody: "Davetiyeniz gerçekten açılıyor mu? Hangi gün kaç kişinin okuttuğunu görün.",
      qrWeek: "Son 7 gün",
      eventsTitle: "Kına + Düğün",
      eventsBody: "İki etkinlik, tek albüm. İlki geçince geri sayım ve mekân kendiliğinden sıradakine döner.",
      eventsKina: "Kına",
      eventsDugun: "Düğün",
      eventsDone: "Gerçekleşti",
      langTitle: "Dört dil",
      langBody: "Türkçe, İngilizce, Fransızca, İspanyolca — her misafir kendi dilini seçer.",
      qualityTitle: "Orijinal kalite",
      qualityBody: "Sıkıştırma yok. Misafirin telefonunda ne varsa albümde o.",
      qualityPhoto: "fotoğraf başına",
      qualityVideo: "video başına",
      notifyTitle: "Anında bildirim",
      notifyBody: "Yeni kare onay beklediğinde Telegram’dan haberiniz olsun.",
      notifySample: "3 yeni fotoğraf onay bekliyor",
    },
    themes: {
      eyebrow: "Davetiye",
      title: "Davetiyeniz bir bağlantı değil.",
      titleAccent: "Bir açılış sahnesi.",
      lead: "QR’ı okutan misafirin karşılaştığı ilk ekran: kaydırdıkça açılan sinematik temalar. Her birini şimdi önizleyin.",
      count: "{{count}} tema",
      preview: "Önizle",
      drag: "Sürükleyerek gezin",
      premium: "Premium",
      classic: "Klasik",
    },
    compare: {
      eyebrow: "Karşılaştırma",
      title: "Neden bir WhatsApp grubu",
      titleAccent: "yetmez?",
      feature: "Özellik",
      colWhatsapp: "WhatsApp grubu",
      colDrive: "Drive klasörü",
      colQrAlbum: "Sıradan QR albüm",
      rowQuality: "Orijinal kalite",
      rowSingle: "Hepsi tek yerde",
      rowLive: "Gece boyunca dev ekranda",
      rowModeration: "Yayından önce onay",
      rowVerified: "Yalnızca doğrulanmış misafirler",
      rowNoApp: "Misafire ek kurulum yok",
      rowVideo: "Video",
      yes: "Var",
      no: "Yok",
      partial: "Kısmen",
    },
    proof: {
      eyebrow: "Çiftler anlatıyor",
      title: "Gerçek düğünler,",
      titleAccent: "gerçek kareler.",
      statWeddings: "düğün albümü",
      statMedia: "kare paylaşıldı",
      rating: "5 üzerinden {{n}}",
    },
    checkout: {
      eyebrow: "Online satın alma",
      title: "Paketinizi satın alın",
      lead: "Paketinizi seçin, bilgilerinizi girin ve siparişi onaylayın. Ödeme havale/EFT ile alınır; ödeme gelince hesabınız açılır.",
      loading: "Yükleniyor",
      closedTitle: "Online satış şu an kapalı",
      closedBody: "Paketlerimizi teklif formundan iki dakikada isteyebilirsiniz; size aynı gün dönüyoruz.",
      closedCta: "Teklif formuna git",
      packageLabel: "Paket",
      packageGuests: "{{n}}’{{suffix}} kadar misafir",
      packageQuote: "Teklif ile",
      name: "Ad soyad",
      email: "E-posta",
      phone: "Telefon",
      eventDate: "Etkinlik tarihi",
      address: "Fatura adresi",
      addressHint: "Sözleşme ve fatura için açık adres.",
      taxId: "TC kimlik / vergi no",
      taxIdHint: "Fatura için; şirket adına alıyorsanız vergi numarası.",
      optional: "isteğe bağlı",
      docsTitle: "Ön bilgilendirme formu ve mesafeli satış sözleşmesi",
      docsLangNote: "Sözleşme metinleri Türkçedir.",
      accept: "Ön bilgilendirme formunu ve mesafeli satış sözleşmesini okudum, kabul ediyorum.",
      summaryTitle: "Sipariş özeti",
      summaryOnce: "Tek seferlik · tüm vergiler dahil",
      summaryPick: "Paketinizi seçin.",
      step1: "1 — Siparişi onaylarsınız.",
      step2: "2 — Ödeme bilgilerini 1 iş günü içinde e-postayla göndeririz.",
      step3: "3 — Ödeme gelince hesabınız açılır, giriş bilgisi e-postanıza gelir.",
      submit: "Siparişi onayla",
      sending: "Gönderiliyor…",
      seller: "Satıcı: {{name}}",
      errField: "Bu alanı kontrol edin.",
      errAccept: "Devam etmek için sözleşmeleri onaylayın.",
      errInvalid: "Bazı alanlar eksik ya da hatalı.",
      errPackage: "Online satın alınabilir bir paket seçin.",
      errVerify: "Güvenlik doğrulaması bekleniyor — birkaç saniye sonra tekrar deneyin.",
      errVerifyFailed: "Güvenlik doğrulaması yüklenemedi. Sayfayı yenileyin ya da teklif formunu kullanın.",
      errClosed: "Bu paket şu an online satılmıyor — teklif formunu kullanın.",
      errUnavailable: "Siparişler şu an alınamıyor. Lütfen teklif formunu kullanın.",
      errTermsChanged: "Fiyat ya da sözleşme koşulları siz okurken güncellendi. Lütfen güncel metni inceleyip yeniden onaylayın.",
      errFailed: "Sipariş gönderilemedi. Lütfen tekrar deneyin.",
      toastSent: "Siparişiniz alındı",
      successTitle: "Siparişiniz alındı",
      successBody: "Sipariş numaranız {{number}}. Ödeme bilgilerini 1 iş günü içinde {{email}} adresine göndereceğiz.",
      successNext: "Ödemeniz hesabımıza geçince organizatör hesabınız açılır; giriş bilgisi ve sözleşmelerin bir kopyası e-postanıza gelir.",
      backHome: "Ana sayfaya dön",
    },
    plans: {
      eyebrow: "Planlar",
      title: "Misafir sayınıza göre",
      titleAccent: "üç paket.",
      lead: "Paketler misafir, fotoğraf/video ve depolama sınırlarıyla ayrılır. Hangisinin size uyduğunu birlikte seçelim.",
      freeTagline: "Denemek ve küçük davetler için",
      proTagline: "Çoğu düğün için",
      maxTagline: "Kalabalık düğünler ve organizatörler için",
      limitGuests: "Misafir",
      guestsUpTo: "{{n}}’{{suffix}} kadar",
      limitMedia: "Fotoğraf ve video / düğün",
      limitStorage: "Depolama",
      recommended: "Önerilen",
      ctaFree: "Ücretsiz paketi iste",
      ctaPaid: "Fiyat al",
      ctaBuy: "Satın al",
      note: "Fiyat, etkinlik ve misafir sayınıza göre belirlenir — formu doldurmanız yeterli.",
      priceOnce: "tek seferlik",
      priceTrial: "ücretsiz deneme",
      priceQuote: "Teklif ile",
      customLine: "Daha kalabalık bir etkinlik mi?",
      customCta: "Özel paket için teklif alın",
      tierGuests: "{{range}} misafir",
      priceNote: "Tek seferlik ödeme, abonelik yok. Kına ve düğün tek fiyatta; masa kartı ve pano tasarımı dahil.",
      retention: "Albüm en az {{months}} ay açık kalır; dilediğiniz an tamamını indirin.",
    },
    print: {
      eyebrow: "Baskı",
      title: "Masalara hazır.",
      titleAccent: "Her yüzey bir davet.",
      lead: "QR kodunuz, düğününüzün diliyle basılsın. Masa kartından karşılama panosuna, örnek tasarımlarımızı indirip inceleyin.",
      tableCard: "Masa kartı",
      tableCardSize: "A6 · 105 × 148 mm",
      sign: "Karşılama panosu",
      signSize: "50 × 70 cm",
      handCard: "El kartı",
      handCardSize: "85 × 55 mm",
      download: "Örnek PDF",
      sampleNote: "Örnek tasarımlar — QR kodu örnek bir davetiye sayfasını açar. Kendi QR’ınızla basılmış hâlleri organizatör panelinden gelecek.",
    },
    contact: {
      eyebrow: "Teklif",
      title: "Fiyatınızı",
      titleAccent: "30 saniyede isteyin.",
      lead: "Misafir sayınızı ve tarihinizi seçin, size nasıl ulaşacağımızı yazın — size özel fiyatı en kısa sürede iletelim.",
      point1: "Kına, nikâh ve düğün tek teklifte",
      point2: "Masa kartı ve pano tasarımı dahil",
      point3: "Satış baskısı yok — yalnızca yanıt",
      directLabel: "Form yerine e-posta mı?",
      directCta: "E-postayla yazın",
      step1: "Etkinliğiniz",
      step2: "Size nasıl ulaşalım?",
      stepCount: "Adım {{n}} / 2",
      next: "Devam",
      back: "Geri",
      addNote: "Not ekle",
      name: "Ad Soyad",
      namePh: "Ayşe Yılmaz",
      email: "E-posta",
      emailPh: "ornek@eposta.com",
      phone: "Telefon",
      eventType: "Etkinlik",
      eventDate: "Etkinlik tarihi",
      package: "Paket",
      packageHint: "Misafir sayınıza uyan paketi seçin; sayılar paket tanımından gelir.",
      packageGuests: "{{n}}’{{suffix}} kadar misafir",
      packageCustom: "Daha kalabalık · özel teklif",
      estimate: "Tahmini fiyat",
      message: "Mesajınız",
      messagePh: "Mekân, saat, aklınızdaki her şey…",
      optional: "isteğe bağlı",
      evWedding: "Düğün",
      evWeddingHenna: "Düğün + Kına",
      evHenna: "Kına",
      evEngagement: "Nişan",
      evPromise: "Söz",
      evOther: "Diğer",
      /** Kademe etiketi — sayılar admin'in sınırlarından (`guestRangeLabel`); tr'de `suffix` yönelme eki. */
      rangeUpTo: "{{n}}’{{suffix}} kadar",
      rangeBetween: "{{min}}–{{max}}",
      rangeOver: "{{n}}+",
      consent: "Teklif talebimin iletilebilmesi için kişisel verilerimin, Aydınlatma Metni’nde belirtilen yurt dışındaki hizmet sağlayıcılara (e-posta ve barındırma) aktarılmasına açık rıza veriyorum.",
      submit: "Fiyat teklifi al",
      sending: "Gönderiliyor…",
      successTitle: "Talebiniz bize ulaştı.",
      successBody: "En kısa sürede {{email}} adresinden ya da telefonla size dönüş yapacağız.",
      successAgain: "Yeni talep gönder",
      errName: "Lütfen adınızı ve soyadınızı yazın.",
      errEmail: "Geçerli bir e-posta adresi yazın.",
      errPhone: "Geçerli bir telefon numarası yazın.",
      errChoice: "Lütfen bir seçenek işaretleyin.",
      errDate: "Bugünden sonraki bir tarih seçin.",
      errConsent: "Devam etmek için onay vermelisiniz.",
      errVerify: "Güvenlik doğrulaması tamamlanmadı; birkaç saniye sonra tekrar deneyin.",
      toastSent: "Talebiniz gönderildi.",
      toastFailed: "Gönderilemedi — talebinizi e-postayla iletebilirsiniz.",
      toastInvalid: "Lütfen işaretli alanları düzeltin.",
      fallbackTitle: "Form şu an gönderilemedi.",
      fallbackBody: "Bilgileriniz hazır bir e-postaya dolduruldu; tek dokunuşla gönderebilirsiniz.",
      fallbackCta: "E-postayla gönder",
      mailSubject: "Teklif talebi — {{name}} · {{event}} · {{date}}",
      mailGreeting: "Merhaba,",
      mailIntro: "{{brand}} için teklif almak istiyorum.",
      mailMessage: "Mesaj",
      mailPlan: "Paket",
      mailClosing: "Teşekkürler.",
    },
    faq: {
      eyebrow: "SSS",
      title: "Merak edilenler",
      q1: "Misafirlerin uygulama indirmesi gerekiyor mu?",
      a1: "Hayır. QR kodu telefon kamerasıyla okutmak yeterli; her şey tarayıcıda açılır. İsteyen ana ekranına ekleyip uygulama gibi kullanabilir.",
      q2: "Fotoğraflar sıkıştırılıyor mu?",
      a2: "Hayır. Dosyalar misafirin telefonundaki haliyle yüklenir — fotoğraf başına {{photo}}, video başına {{video}} sınırına kadar.",
      q3: "Albümü kimler görebilir?",
      a3: "Yalnızca telefon numarasını doğrulayarak giriş yapan misafirler — onlar da yalnızca sizin onayladığınız kareleri görür.",
      q4: "Uygunsuz bir kare ekrana düşer mi?",
      a4: "Düşmez. Her kare önce moderasyon kuyruğuna gelir; Sahne’de yalnızca onayladıklarınız döner. Gerekirse paylaşanı tek dokunuşla engellersiniz.",
      q5: "Kına ve düğün için ayrı albüm mü açmalıyım?",
      a5: "Gerek yok. İki etkinliği aynı düğüne tanımlarsınız; ilki geçince geri sayım ve mekân bilgisi kendiliğinden ikincisine döner.",
      q6: "Sahne için ne gerekiyor?",
      a6: "İnternete bağlı bir ekran ya da projektör ve bir tarayıcı. Sahne’yi tam ekran açın, akışı Reji’den telefonunuzla yönetin.",
      q7: "Misafirlerimin bir kısmı yabancı; sorun olur mu?",
      a7: "Olmaz. Arayüz Türkçe, İngilizce, Fransızca ve İspanyolca; her misafir kendi dilini seçer.",
      q8: "Albüm ne kadar süre açık kalır?",
      a8: "Albümünüz en az {{months}} ay açık kalır. Bu sürede onaylı tüm fotoğraf ve videoları panelden tek tıkla, orijinal kalitesiyle ZIP olarak indirebilirsiniz.",
    },
    finale: {
      title1: "Gece bitmeden,",
      title2: "en güzel kareler",
      title3: "salonda.",
      lead: "Fiyatınızı alın; QR kodunuz masalara basılmaya hazır olsun.",
      cta: "Fiyat al",
      secondary: "Örnek davetiyeyi aç",
    },
    footer: {
      tagline: "Kaçırdığınız her an, tek albümde.",
      product: "Ürün",
      account: "Hesap",
      organizerLogin: "Organizatör girişi",
      quote: "Fiyat al",
      demo: "Örnek davetiye",
      rights: "Tüm hakları saklıdır.",
    },
  },
  weddingTelegram: {
    title: "Telegram bildirimleri",
    subtitle: "Bu düğünün olayları seçtiğiniz Telegram sohbetlerine gelir: kendi sohbetiniz ya da çiftin / ekibin grubu.",
    unavailable: "Telegram bildirimleri şu an kurulamıyor (sistem güncellemesi bekleniyor).",
    botMissing: "Telegram botu yapılandırılmamış — yöneticiye haber verin.",
    loadFailed: "Telegram bağlantıları yüklenemedi.",
    retry: "Tekrar dene",
    connectPrivate: "Kendi Telegram'ıma bağla",
    connectPrivateHint: "Bildirimler yalnız size gelir.",
    connectGroup: "Bir gruba ekle",
    connectGroupHint: "Çiftin ya da ekibin grubu — grubu Telegram'da seçersiniz.",
    waitingPrivate: "Telegram'da açın ve “Başlat”a dokunun. Bağlanınca burada görünür.",
    waitingGroup: "Telegram'da grubu seçin ve botu ekleyin. Bağlanınca burada görünür.",
    openTelegram: "Telegram'da aç",
    expiresIn: "Bağlantı {{time}} geçerli",
    expired: "Bağlantının süresi doldu. Yeniden oluşturun.",
    cancel: "Vazgeç",
    linked: "Telegram bağlandı: {{name}}",
    linkFailed: "Bağlantı oluşturulamadı",
    chatsTitle: "Bağlı sohbetler",
    empty: "Henüz bağlı sohbet yok.",
    private: "Kişisel",
    group: "Grup",
    unnamedPrivate: "Kişisel sohbet",
    unnamedGroup: "Grup",
    eventsLabel: "{{name}} için bildirim türleri",
    remove: "Kaldır",
    removeConfirm: "“{{name}}” bu düğünün bildirimlerini artık almayacak. Kaldırılsın mı?",
    removed: "Sohbet kaldırıldı",
    saved: "Bildirim seçimi kaydedildi",
    saveFailed: "Kaydedilemedi",
    stale: "Seçim başka bir yerde değişmiş — güncel hâli yüklendi.",
    footer: "Botu engellerseniz ya da gruptan çıkarırsanız bağlantı kendiliğinden kalkar. Sohbette /status bağlı düğünleri gösterir.",
    events: {
      media_upload: "Yeni medya (onay bekliyor)",
      guest_join: "Yeni misafir",
      rsvp_submitted: "LCV yanıtı",
      comment_created: "Yorum",
      capacity: "Kota uyarıları",
    },
    errors: {
      migration_required: "Telegram bildirimleri şu an kurulamıyor (sistem güncellemesi bekleniyor).",
      bot_unavailable: "Telegram botuna ulaşılamadı, biraz sonra tekrar deneyin.",
      generic: "Hata: {{error}}",
    },
  },

} as const;

export default tr;
export type TranslationKeys = typeof tr;

/** Değerleri geniş `string`'e çeviren, anahtar kümesini AYNEN koruyan yardımcı. */
type DeepWiden<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepWiden<T[K]>;
};

/**
 * `en.ts` / `fr.ts` / `es.ts` anotasyonu — tr.ts ile aynı anahtar kümesi, serbest değerler.
 *
 * Neden doğrudan `TranslationKeys` değil: `tr` `as const` olduğu için `TranslationKeys`
 * değerleri Türkçe *literal* tipleridir (`"Kaydet"`), bu da `en.ts`'i baştan sona kırar.
 *
 * Yakaladığı: EKSİK anahtar (tsc/editör anında kırmızı).
 * Yakalamadığı: FAZLA anahtar — ana mekanizma `src/__tests__/locales.test.ts` parity testi.
 */
export type TranslationDict = DeepWiden<TranslationKeys>;
